const es = {
  dateStartBeforeDateFinal: "La fecha de inicio no puede ser supeior a la fecha final",
  applyFilter: "Aplicar Filtro",
  rangeDateInfo: "Si no se introduce ninguna fecha (inicial o final), el informe mostrará los datos de todo el periodo, a partir de la fecha de registro del jugador.",
  seeNotification: "Ver",
  viewed: "Visto",
  notViewed: "No visto",
  wantToDeleteThisMessage: "¿Desea eliminar este mensaje?",
  deleteMessage: "Eliminar mensaje",
  editMessage: "Editar mensaje",
  addNotificationText: "Por defecto, el sistema envía mensajes a todos los jugadores. Para enviar mensajes a jugadores concretos, busca por nombre o ID a continuación",
  seeSelectedUsers: "Ver los usuarios seleccionados (ID)",
  newMessage: "Nuevo mensaje",
  selectTags: "Seleccionar etiquetas",
  massImportAffiliatesMIN: "Debe tener al menos 1 (un) usuario para importar",
  massImportAffiliatesMAX: "Sólo puede importar 1000 (mil) afiliados a la vez",
  massImportAffiliatesRequiredColumns: `Máximo de 1000 afiliados por importación.<br> Las columnas "local_manager_id", "login", "name" y "password" son obligatorias para importar afiliados en masa.`,
  massImportAffiliates: "Importar afiliados en masa",
  importAffiliates: "Importar afiliados",
  someErrorsWereFound: "Se han encontrado algunos errores",
  operationLog: "Registro de operaciones",
  noTagsCreated: "No se han creado etiquetas.",
  prizeFreespinsQtt: "Cant. Freespins premios",
  prizeFreespinsAmount: "Total de premios freespins",
  casinoReferenceDay: "Día de referencia",
  prizeRefundAmount: "Reembolso total del premio",
  prizeRefundQtt: "Ctd. Reembolso del premio",
  betRefundAmount: "Reembolso total de la apuestas",
  betRefundQtt: "Ctd. Reembolso de apuestas",
  gameId: "ID Juego",
  registeredUsers: "Usuarios registrados",
  usersByCampaign: "Usuarios por campaña",
  wonBet: "Gane",
  lostBet: "Perdido",
  resultDate: "Fecha del resultado",
  numberOfGames: "Número de partidas",
  multiplier: "Multiplicador",
  consultedOn: "Consultado el",
  irreversibleAction: "Esa acción es irreversible.",
  tagsConfig: "Etiquetas",
  createTag: "Crear etiqueta",
  createNewTag: "Crear nueva etiqueta",
  seeTags: "Ver etiquetas",
  playerTags: "Etiquetas de jugador",
  addTag: "Agregar etiqueta",
  addTags: "Agregar etiquetas",
  removeTags: "Eliminar etiqueta | Eliminar etiqueta | Eliminar etiquetas",
  confirmRemoveTagText: "¿Está seguro de que desea eliminar las etiquetas seleccionadas?",
  maxTagsReached: "Se alcanzó el número máximo de 5 etiquetas",
  noTagsAvailable: "No hay etiquetas disponibles",
  tipRemoveTag: "Consejo: Haga clic en la etiqueta que desea eliminar de este reproductor",
  tipSelectMaxTags: "Seleccione hasta {maxQtyPlayerTags} etiquetas",
  yourTags: "Tus etiquetas",
  manageTags: "Administrar etiquetas",
  editTags: "Editar etiquetas",
  color: "Cor",
  selectColor: "Seleccione un color",
  selectTag: "Seleccione una etiqueta",
  noTagFound: "No se encontraron etiquetas",
  create: "Crear",
  insertTitle: "Insertar un título",
  seeGames: "Ver juegos",
  irreversibleActionExemptPlayer:
    "Esta acción es irreversible: el reproductor vinculado no se puede editar ni eliminar.",
  playerName: "Nombre del jugador: {playerName}",
  searchExemptPlayer: "Búsqueda de jugadores exentos",
  searchAffiliate: "Buscar afiliado(s)",
  linkExemptPlayerBtn: "Jugador exento de enlace",
  linkAffiliateExemptPlayerBtn: "Enlace a un jugador exento",
  linkExemptPlayerAffiliates: "Vincular jugador exento a afiliado(s)",
  linkAffiliateExemptPlayer: "Vincular afiliado a un jugador exento",
  idTransaction: "ID de transacción",
  typePix: "Tipo de Pix",
  valueCpa: "Valor CPA",
  loadingData: "Cargando datos",
  cpaLabel: "CPA",
  playerId: "ID Jugador",
  details: "Detalles",
  cpaValue: "CPA Valor",
  cpaType: "CPA Tipo",
  lclManager: "Ger. Local",
  regManager: "Ger. Regional",
  percent: "Porcentaje",
  noCommission: "Sin comisión",
  chooseGroupByOption:
    "Es necesario elegir una opción en Agrupar por: juego o proveedor.",
  lobbyAll: "Lobby: Todos",
  newCasino: "Nuevo Casino",
  providerCategories: "Categorías de Proveedor",
  gameSettings: "Ajustes del juego",
  chooseAtLeastOneCategoryOrProvider:
    "Es necesario elegir al menos una categoría personalisada o un proveedor.",
  casinoVolatility: `La volatilidad la proporcionan los proveedores de juegos.
  Esto se utiliza para indicar a los jugadores con qué frecuencia
  cómo la tragamonedas asigna los pagos y qué tan altos podrían
  esperar los pagos.`,
  casinoRTP: `RTP: El retorno al jugador, o RTP, en cualquier juego,r
  es el porcentaje esperado de montos apostados que
  un juego específico volverá al jugador en el transcurso de
  un período de tiempo.`,
  high: "Alta",
  "very-high": "muy-alta",
  medium: "Media",
  "medium-high": "Media-alta",
  low: "baja",
  "low-medium": "medio-bajo",
  payout: "Pago",
  guestBy: "Mostrar 'Indicado por'",
  volatilityRating: "Volatilidad",
  commissionTypeCpa: "Tipo de Comisionamiento",
  maxValueCommission: "Valor Máximo de Comisión",
  minDepositCpa: "Valor Mínimo de Depósito",
  turnover: "Turnover para Depósito",
  commissionCpa: "Comisionamiento por CPA",
  tooltipCpa: `Costo Por Acción<br>
  <ul>
  <li>Tipo de comisión: Referente a cada primer depósito de un jugador.</li>
  <li>Valor mínimo de depósito: Valor mínimo del primer depósito de cada jugador.</li>
  <li>Valor máximo de comisión: Valor máximo que su afiliado recibirá como comisión según el CPA definido.</li>
  </ul>`,
  tooltipTurnover:
    "Para que el afiliado sea comisionado, el jugador debe utilizar el monto depositado en apuestas deportivas o juegos de casino.",
  withoutCommission: "Sin Comisionamiento",
  percentage: "Porcentaje",
  fixedRate: "Tasa Fija",
  categoryWeight: "Peso de la categoria",
  categoryWeightTxt:
    "El 'peso de la categoría' determina la ubicación de una categoría en la lista del casino. Por ejemplo: una categoría de 'Juegos populares' que tenga un peso de 50 aparecerá en la lista antes que una categoría de 'Juegos nuevos' que tenga un peso de 40. El peso de una categoría puede oscilar entre 0 y 999.",
  customCategories: "Categorías Personalizadas",
  systemGameStatus: "Estado del juego en el sistema",
  visibleGameTxt: `
    <span class="mb-4">El juego se mostrará si:</span>
    <ul>
      <li>Estar incluido en al menos una categoría</li>
      <li>Al menos una categoría debe estar activa</li>
      <li>El estado del juego en el sistema debe estar activo</li>
    </ul>
  `,
  noDescription: "No hay una descripción",
  selectCategory: "Selecciona una categoría",
  gameDisplayed: "Juego mostrado",
  casinoTheme: "Tema",
  verticalCategory: "Categoría vertical",
  showLess: "Mostrar menos",
  showMore: "Mostrar más",
  filterByVerticalCategory: "Filtrar por categoría de proveedor",
  filterByCasinoTheme: "Filtrar por tema de casino",
  readLess: "Leer menos",
  readMore: "Leer más",
  lobbyCasino: "Lobby: Casino",
  lobbyCasinoLive: "Lobby: Casino En Vivo",
  filterByCategories: "Filtrar por categoría personalizada",
  filterByGameProviders: "Filtrar por proveedores",
  filterByLobby: "Filtrar por Lobby",
  noCategory: "Sin categoría",
  others: "otros",
  outras: "otras",
  image: "Imagen",
  gamesProviders: "Proveedores de juegos",
  categoryNameLabel: "Nombre de la categoría",
  areYouSureToDelete: "¿Está seguro de que desea excluir la categoría?",
  deletingCategoryAlert:
    "La siguiente acción eliminará la categoría de juegos existente y los juegos configurados para aparecer en esta categoría perderán este estado. Puede configurarlos para que aparezcan en otras categorías.",
  customCategory: "Categoría personalizada",
  standardCategory: "Estándar",
  casinoType: "Tipo de Casino",
  createCategory: "Crear categoría",
  editCategory: "Editar categoría",
  deleteCategory: "Eliminar Categoría",
  ativa: "Activa",
  inativa: "Inactiva",
  weight: "Peso",
  categories: "Categorías",
  games: "Juegos",

  noDataOptions: "No hay opciones disponibles",
  noDataTablePlayers: "No hay jugadores para listar",
  filterBy: "Filtrar Por",
  dataByRegion: "Datos por Región",
  qtdPlayers: "Cantidad de Jugadores",
  homeGraphicTitle: {
    overviewDescription:
      "Transacciones con saldo en línea de Apuestas Deportivas y Casino.",
    sports: "Apuestas Deportivas",
    casino: "Apuestas de Casino",
    offensivePlayers: "Jugadores Contra la Casa",
    noOffensivePlayers: "Jugadores a Favor de la Casa",
    averageDailyDescription:
      "Ticket Promedio: {average} | Primas Promedio: {average} | Ingreso Diario Promedio: {average}",
  },
  homeChartLineOptions: {
    sports: {
      title: "Apuestas Deportivas - Gráfico",
      // verticalLabel: "R$",
      horizontalLabel: "Día/Mes",
    },
    casino: {
      title: "Apuestas de Casino - Gráfico",
      // verticalLabel: "R$",
      horizontalLabel: "Día/Mes",
    },
  },
  listAndExportTokensTip: "Listar / Exportar Tokens",

  redeemedTokens: "Tokens canjeados",
  dateUse: "Fecha de activación",
  quantityOfTokensAsterisk: "Cantidad de tokens *",
  quantityOfTokens: "Cantidad de tokens",
  notRansomed: "No rescatados",
  ransomed: "Rescatados",
  exportTokens: "Exportar Tokens",
  token: "Token",
  usersActivesByAffiliateTooltip:
    "Usuarios activos mínimos alcanzados | Faltan 1 usuario activo | Faltan {remainingUsers} usuarios activos",
  usersActivesByAffiliateExplanation:
    "Para ser comisionado, debe alcanzar la cantidad mínima de usuarios activos",
  qtyUsersActives: "Cantidad de usuarios activos",
  usersActivesByAffiliate: "Usuarios activos / mínimos",
  minActiveUsers: "Usuarios Activos Mínimos",
  differentAspectRatio:
    "La imagen está en una proporción diferente a la esperada",
  exportAdhesions: "Exportar adherencias",
  claimExport: "Exportar reclamar",
  exportTransfers: "Exportar transferencias",
  minutes: "minuto | minuto | minutos",
  hour: "hora",
  hourCapitalized: "Hora",
  balanceType: "Tipo de Saldo",
  realBalance: "Saldo Real",
  agentBet: "Apuesta Agente",
  onlineBetting: "Apuestas en Línea",
  allBets: "Todas las Apuestas",
  toManyTryLogin:
    "Se bloqueó el acceso a su dispositivo durante {timeLeft} debido a varios intentos de inicio de sesión.",
  defaultFeeError: "A Tarifas es de 0 a 99. Use números enteros",
  maxPercentageFeeValue: "A Tarifas es de 0 a 99. Use números enteros",
  defaultFeeTooltip:
    "La tarifa estándar es una tarifa de servicio que se aplicará sobre el GGR del afiliado. Puede cambiar esta tarifa individualmente, al registrar un nuevo afiliado, desmarcando la opción 'Aplicar tarifa estándar'",
  defaultFee: "Tarifa Estándar",
  defaultFeeSettingsAndVariableCommissions: "Configuraciones de Afiliados",
  updateAffiliateVariableCommission: "Actualizar Comisión Variable de Afiliado",
  updateAffiliateCommissionType: "Actualizar tipo de comisión de afiliado",
  updateFixedAffiliateCommission: "Actualizar Comisión Fija de Afiliados",
  updateAffiliateFee: "Actualizar tarifa de afiliado",
  requestedByCustumer: "Cancelación solicitada por el jugador",
  reason2: "Clave incorrecta, ajústela y solicite de nuevo",
  reason3: "Las acciones de los jugadores violan nuestras políticas",
  cancelWithdrawByOperator: "Retiro Cancelado por el Operador",
  // reasonCancelWithdrawLabel: "Ingrese el motivo",
  cancelWithdraw: "Cancelar Retiro",
  adviseCancelWithdraw: "Se enviará un SMS al jugador con el motivo:",
  feeValue: "Valor de la Tarifa",
  feeValueCommission: "Valor de la Comisión",
  prizesCasino: "Premios Casino",
  betCasino: "Apuestas Casino",
  betCasinoQty: "Qtd. Apuestas Casino",
  prizeCasinoQty: "Qtd. Premios Casino",
  betsPrizeQty: "Qtd. Premios",
  activePlayers: "Jugadores Afiliados",
  analyticReport: "Informe Analítico",
  draggableHint:
    "¡Puede cambiar el orden de visualización de los banners arrastrando las imágenes a la posición deseada!",
  urlNo: "Ingrese un valor URL.",
  addPromotionUser: {
    title: "Vincular promoción a una usuario",
    selectDeposit: "Seleccionar depósitoo",
    infoUser:
      "Este usuario está vinculado a la promoción '{titlePromo}'. Si confirma el enlace, perderá el progreso actual del rollover y si alguna apuesta relacionada con la promoción anterior está pendiente, ya no será válida.",
    error: {
      selectPlayer: "Selecciona un jugador",
      noDeposits: "Usuario sin depósitos",
      selectDeposit: "Seleccione un depósito",
    },
    success: "Promoción añadida por el usuario",
  },
  removeCasinoGamesByAdm: "Eliminar Juegos de Casino",
  insertCasinoGamesAdm: "Insertar Juegos de Casino",
  updateOperatorPaymentMethods: "Actualizar los Métodos de Pago del Operador",
  seePromotion: "Ver promoción",
  tokenTip:
    "El token es un código único y exclusivo generado aleatoriamente que solo puede ser activado una vez por un usuario de apuestas. Ingrese la cantidad de tokens que desea crear para esta promoción. Ex.: 1000",
  bonusMax: "Bono Máximo",
  promotionDetails: "Detalles de la promoción",
  multMaxValueTip:
    "Determina el multiplicador máximo a apostar con el bono proveniente de esta promoción. Ej.: Con este bono no se permitirán apuestas con un multiplicador total superior a 12,55.",
  multMinValueTip:
    "Determina el multiplicador mínimo para apostar con el bono proveniente de esta promoción. Por ejemplo: Con este bono no se permitirán apuestas con un multiplicador total inferior a 2,23.",
  stakeMinValueTip1:
    "Es la cantidad mínima que se aceptará por apuesta en esta promoción. Ej.: El bono sólo será válido para apuestas de",
  stakeMinValueTip2: "5.",
  depositMinValueTip:
    "Monto mínimo que el apostador necesita depositar para poder unirse a la promoción.",
  bonusMaxValueTip:
    "Cantidad máxima que se acreditará en bonos después de contar el porcentaje sobre la cantidad depositada.",
  prmotionTypeRegisterOrAfiliateTip:
    "Importe neto en bonificación que se acreditará tras el registro de esta promoción.",
  promotionTypeDepositTip:
    "Porcentaje sobre el monto depositado que se acreditará como bonificación al unirse a esta promoción.",
  promotionCodeTip:
    "Código que utilizará el apostante para unirse a la promoción. Ej.: AFILIADOGANHA200, NOVOCADASTRO100, etc.",
  bonusTotalResgatado: "Bonificación Total Canjeada",
  bonusTotalConcedido: "Bono Total Otorgado",
  promotion: "Promoción",
  startBonus: "Bono de Inicio",
  notInForce: "No en vigor",
  inForce: "En vigor",
  userExtract: "Declaración de usuario",
  adhesionTooltip: "Lista de usuarios que se han sumado a esta promoción",
  pleaseStandBy: "Espere por favor...",
  redeemed: "Canjeada",
  encerrada: "Cerrada",
  suspensa: "Suspendida",
  ativas: "Activas",
  inativas: "Inactivas",
  adhesionExtract: "Extracto de Adhesión",
  subsequentBalance: "Saldo posterior",
  applyDefaultFee: "Aplicar tarifa predeterminada",
  nameOperation: "Nombre de la operación",
  entryDate: "fecha de lanzamiento",
  userStatus: "Status del Usuario",
  expiration: "Vencimiento",
  currentRollover: "Rollover actual",
  totalRollover: "Rollover total",
  idBanca: "ID Banca",
  idPromotion: "ID Promoción",
  adhesions: "Adherencias",
  adhesion: "Adherencia",
  searchById: "Buscar por ID",
  deletedImage: "¡Imagen eliminada!",
  noImageLoaded: "Ninguna imagen cargada",
  deleteImage: "Eliminar",
  warningMaxSize: "La imagen excede el tamaño permitido: 1800x700",
  loadImageSuccess: "¡Imagen cargada con éxito!",
  timeStart: "tiempo de inicio",
  day: "día",
  idAffiliate: "ID Afiliado",
  promotionCode: "Código de promoción *",
  promotionCodeTableHeader: "Código de promoción",
  loadImage: "Cargar imagen",
  acceptedFormats: "Formatos aceptados: .png, .jpg, .jpeg",
  inactivePromo: "Inactiva",
  showMainEvents: "¿Mostrar Eventos Principales?",
  activePromo: "Activa",
  finalizedPromo: "Terminada",
  cancelledPromo: "Cancelada",
  expiredPromo: "Caducado",
  commissionLive: "En línea",
  commissionPrematch: "Prejuego",
  LabelMaximumBonusAmount: "Importe máximo de bonificación",
  autoCompleteAffiliatePlaceHolder: "Ingrese un nombre para la consulta *",
  addImage: "Añadir imagen",
  maxTransference: "Transferencia máxima",
  dialogCommissionLive:
    "Si hay al menos un evento en vivo en la apuesta, se aplica la comisión en vivo.",
  rulesAndOperation: "Reglas y funcionamiento",
  rolloverDetails: "Detalles de Rollover",
  percentageLabel: "%",
  minimumDeposit: "Depósito Mínimo",
  daysToExpire: "Días para expirar *",
  daysToExpireTableHeader: "Días para expirar",
  days: "días",
  cashoutDetachedAuthorizedByCollab: "Retiro Manual Autorizado Por Colaborador",
  cashoutDetachedAuthorizedByAdm: "Retiro Manual Autorizado Por Administrador",
  detachedDepositByAdm: "Depósito Manual Online Por Administrador",
  detachedDepositByColab: "Depósito Manual Online Por Colaborador",
  customLandingPages: "Páginas de destino personalizadas",
  LPTitleLabel: "Título",
  errorUploadingLandingPage: "¡Ha ocurrido un error! Vuelva a intentarlo.",
  successLandingPage: "¡Página de destino enviada con éxito!",
  textAreaWithoutCode:
    "¡Necesitamos el código fuente para guardar la página de destino!",
  landingPagePlaceHolder:
    "Pegue el código fuente de su página de destino aquí. O utilice nuestra plantilla editable haciendo clic en 'Cargar plantilla'.",
  medias: "Medios",
  gameName: "Nombre del Juego",
  of: "de",
  eventNumber: "Numero de Eventos",
  verificationNotStarted: "No Verificado",
  verificationSuccess: "Verificado",
  verificationInProgress: "En Proceso",
  verificationDenied: "Verificación Negada",
  collaboratorTooltip:
    "Los Colaboradores son personas que no necesitan acceso completo al sistema. Cree grupos de permisos y luego asígnelos a Colaboradores.",
  groupsTooltip:
    "Los grupos son los permisos asignados a un Colaborador. Permitirán o no al Colaborador ver menús o realizar acciones.",
  loginAsCollaborator: "Iniciar sesión como Colaborador",
  atLeastOneOption: "¡No seleccionó una permiso!",
  emptyFields: "Hay campos sin llenar",
  selectPermissions: "Seleccionar acciones:",
  insertNewGroupName: "Inserte el nuevo nombre del grupo:",
  groupName: "Nombre del grupo",
  group: "Grupo",
  managed: "Administrado",
  createPermissionsGroup: "Nuevo Grupo de Permisos",
  permissions: "Permisos",
  listPermissions: "Lista de Permisos",
  updatePermissions: "Editar Permisos",
  listCollaborators: "Lista de Colaboradores",
  collaborator: "Colaborador",
  collaborators: "Colaboradores",
  block: "Bloquear",
  editCollaboratorRegisterData: "Editar dados de registro",
  groups: "Grupos",
  editCollaborator: "Editar Colaborador",
  newCollaborator: "Nuevo Colaborador",
  registerCollaborator: "Registrar Colaborador",
  idUser: "ID Usuario",
  warningAboutBanks:
    "¡Cuidado! Al eliminar un banco, el jugador que tiene una clave de pix verificada con ese banco deberá pasar por el proceso de verificación nuevamente.",
  allowedBanksConfiguration: "Configuración de Bancos",
  selectAtLeastOneBank: `Seleccione al menos un banco o establezca la verificación bancaria en "No".`,
  languages: "Idiomas",
  termsOfUse: "Términos de Uso",
  responsibleGambling: "Juego Responsable",
  dataProtection: "Protección de Datos",
  aml: "AML",
  totalBetsValue: "Total Apuestas",
  totalBetsAmount: "Cant. de Apuestas",
  totalValidBetsValue: "Total Válidas",
  totalValidBetsAmount: "Cantidad Válidas",
  totalRefundedBetsValue: "Total Devueltas",
  totalRefundedBetsAmount: "Cantidad Devueltas",
  totalPrizesValue: "Premios",
  totalPrizesAmount: "Cant. de Premios",
  groupBy: "Agrupar por",
  document: "Documento",
  documents: "Documentos",
  betCashout: "Retiro de Apuesta",
  chooseBanks: "ELEGIR BANCOS",
  bankVerification: "Verificación Bancaria",
  banks: "Bancos",
  allowedBanks: "Seleccione los bancos permitidos:",
  startTypingABank: "Empieza a escribir un banco",
  chooseBanksHint: `
    Si desea restringir los bancos, seleccione "Sí" y elija los bancos que desea permitir. (Recomendado) <br/>
    Si desea permitir todos los bancos, puede seleccionar "No".
    `,
  selectAll: "Selecionar todos",
  removeAll: "Remover todos",
  playerNameIsRequired: "¡Ingresa un ID, nombre, login, teléfono o Email!",
  autoCompleteNoData: "Sin datos de consulta",
  cantCalculateSurebet:
    "No es posible calcular la ganancia ya que una o más cuotas están suspendidas.",
  surebetFormula: "Cálculo estimado basado en la fórmula de Surebet",
  hideEstimatedProfit: "Esconder beneficio estimado",
  showEstimatedProfit: "Mostrar beneficio estimado",
  selectAgent: "Seleccione un agente.",
  firstDeposit: "Primer depósito",
  finishedBet: "Cerrada",
  finishedBetPlural: "Cerradas",
  withTransactions: "Exportar por jugador que realizó depósito o retiro",
  noRegister: "No hay registro",
  activation: "Activación",
  suspension: "Suspensión",
  massAgentsUpdateTitle: "Actualización Masiva de Agentes",
  massAgentsUpdateTitleMobile: "Actualización de Agentes",
  massAgentsUpdateContent:
    "Elija una acción para realizar en los agentes del gerente {managerName}.",
  massAgentsSuspensionTitle: "Suspensión Masiva de Agentes",
  massAgentsSuspensionTitleMobile: "Suspensión de Agentes",
  massAgentsSuspensionContent:
    "Todos los agentes del gerente serán suspendidos. ¿Estás seguro de que quieres continuar?",
  massAgentsActivationTitle: "Activación Masiva de Agentes",
  massAgentsActivationTitleMobile: "Activación de Agentes",
  massAgentsActivationContent:
    "Se Todos los agentes del gerente serán activados. ¿Estás seguro de que quieres continuar?",
  bonusConsumed: "Bono Consumido",
  groupCreated: "Grupo Creado",
  groupUpdated: "Grupo Actualizado",
  promotionInserted: "Promoción Insertada",
  promotionDeleted: "Promoción Eliminada",
  changingStatusOfSelfSuspendedPlayer:
    "No es posible cambiar el estado de un jugador autosuspendido.",
  suspendedSince: "Suspendido desde: ",
  selfSuspended: "Autosuspendido",
  limitSuspensionDate: "Suspendido hasta",
  playerSuspended: "Suspensión del Jugador",
  doubleAccount: "Más de Una Cuenta",
  suspiciousBehavior: "Comportamientos Sospechosos",
  textAreaPlaceholderSuspension:
    "Ingrese una breve razón para la suspensión del usuario.",
  textAreaPlaceholderDisable:
    "Ingrese una breve razón para deshabilitar al usuario.",
  suspensionReason: "Razón",
  disableReason: "Razón de la Desactivación",
  warningDisable:
    "Esta acción solo se puede deshacer abriendo un ticket con soporte.",
  bugAbuse: "Abuso de Fallas del Sistema",
  outdatedInformation: "Información Desactualizada",
  termsAndConditionsViolation: "Violación de Términos y Condiciones",
  financialProtection: "Protección Financiera",
  other: "Otro",
  selectAReasonToSuspend: "Seleccione una razón para suspender al usuario",
  selectAReasonToDisable: "Seleccione una razón para deshabilitar al usuario",
  depositBalance: "Saldo de Depósito",
  loginButton: "Entrar",
  editAgentBalance: "Editar el Saldo del Agente",
  agentBalance: "Saldo del agente",
  incrementAgentBalance: "Adición ao saldo del agent",
  totalOnlineBalanceDescription: "Saldo total de usuarios en línea",
  onlineBalance: "Saldo en Línea",
  bonusBalance: "Saldo de Bonificación",
  totalOnlineBalance: "Saldo",
  paymentMethods: "Meios de Pago",
  depositForPlayerPayment: "Pagamento do depósito",
  depositForPlayerPixDescription:
    "Estás haciendo un depósito para un jugador. El método de pago es PIX, y la cantidad de $ {value} se acreditará en la cuenta del jugador unos segundos después de que se confirme el pago.",
  depositForPlayerManualDescription:
    "Estás haciendo un depósito manual para un jugador. $ {value} se acreditará en la cuenta del jugador.",
  depositForPlayer: "Depósito",
  login: "Acceso",
  betsWithDeposit: "Apuestas con Saldo de Depósito",
  betsWithBonus: "Apuestas con Saldo de Bonificación",
  copyCode: "Copiar codigo",
  portuguese: "Portugués",
  spanish: "Español",
  english: "Inglés",
  hiWelcome: "¡Hola es bienvenido!",
  navigateSideMenu: "Navega por el menú lateral.",
  print: "Imprimir",
  paidBets: "Pagar apuestas",
  paidBet: "Pagar Apuesta",
  wantPaidBet: "¿Quieres pagar la apuesta",
  search: "Buscar",
  live: "En vivo",
  resumeSummary: "Resumen del período",
  value: "Valor",
  prizePaids: "Primas pagadas",
  prizePossibles: "Posibles premios",
  prizeTotal: "Premios totales",
  code: "Código",
  info: "Informácion",
  events: "Eventos",
  dateHour: "Fecha/Hora",
  return: "Ganancia",
  result: "Resultado",
  action: "Acciones",
  activeAgents: "Agentes activos",
  weeklyChart: "Gráfico semanal",
  grossAndPremium: "Bruto y prima",
  from: "De",
  areas: "Áreas",
  until: "Hasta",
  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
  saturday: "Sábado",
  sunday: "Domingo",
  gross: "Bruto",
  labelCurrency: "$",
  awards: "Premios",
  informations: "Información",
  dateTime: "Fecha / Hora",
  paid: "Pagado",
  actions: "Acciones",
  canceledList: "Lista cancelada",
  deferredList: "Lista diferida",
  view: "Ver",
  periodSummary: "Resumen del período",
  paidPremiuns: "Primas pagadas",
  passibleAwards: "Posibles premios",
  totalPrizes: "Total de premios",
  cancelledIn: "Cancelado en",
  amount: "Cantidade",
  player: "Jugador",
  sellerCode: "Cód. de vendedor",
  operation: "Operación",
  commission: "Comisión",
  status: "Estado",
  cancelCredit: "Cancelar crédito",
  msgConfirmCancelCredit: "¿Realmente desea cancelar el crédito de",

  consultedBy: "Consultado por",
  dayAndTimeOfPrinting: "Día y hora de impresión",
  newRegionalManager: "Nuevo gerente regional",
  name: "Nombre",
  createdIn: "Creado en",
  edit: "Editar",

  registrationForm: "Formulario de registro",
  fullName: "Nombre completo",
  settings: "Configuración",
  profitCommission: "Comisión de beneficios",
  areaOfExpertise: "Área de especialización",
  regionalCreditforAgents:
    "¿Puede esta Regional administrar el crédito para agentes?",
  regionalLimitsforAgents:
    "¿Puede esta región administrar los límites de los agentes?",
  credentials: "Credenciales",
  changePassword: "Cambiar contraseña",
  password: "Contraseña",
  confirmPassword: "Confirmar Contraseña",
  toSave: "Guardar",
  yes: "Sí",
  no: "No",
  thisFieldIsRequired: "Este campo es obligatorio",
  repeatPassword: "Repetir contraseña",
  activate: "Activar",
  pending: "Pendiente",
  supend: "Suspender",
  disable: "Deshabilitar",
  // newLocalManager: "Nuevo administrador local",
  profile: "Perfil",
  regionalManager: "Gerente Regional",
  localCreditforAgents:
    "¿Puede este sitio administrar el crédito de los agentes?",
  localLimitsforAgents:
    "¿Puede este sitio administrar los límites de los agentes?",
  localAdminPaidBets: "¿Este sitio puede administrar los pagos de apuestas?",
  newAgent: "Nuevo Agente",
  commissions: "Comisións",
  viewBets: "Ver apuestas",
  mLocal: "G. Local",
  mRegional: "G. Regional",

  subordination: "Subordinación",
  mobile1: "Móvil 1",
  mobile2: "Móvil 2",
  address: "Dirección",
  toSaveStateMsg:
    "Para guardar un estado y una ciudad, debe ingresar un código postal válido.",
  state: "Estado",
  limits: "Límites",
  valuePerMatch: "Valor por partido (en apuesta única)",
  dailyBettingLimit: "Límite diario de apuestas",
  dailyLimitSingleBets: "Límite diario para apuestas individuales",
  dailyLimitDoubleBets: "Límite diario para apuestas dobles",
  maximumAgentAward: "Premio máximo al agente",
  creditSaleLimit: "Límite de venta de crédito",
  generalSalesLimit: "Límite general de ventas",
  generalSalesLimitIncrement: "Adición ao límite general de ventas",
  reset: "Reiniciar",
  activateLive: "Activar en vivo",
  vieAwardees: "Ver premiados",
  automaticPayment: "¿Pago automático?",
  marginOfQuotation: "Margen de cotización",
  commissionsOnCreditSales: "Comisión sobre ventas a crédito",
  maximumMutiplier: "Mult. de apuesta Máx. ",
  minimumMultiplier: "Mult. de apuesta Mín.",
  // accessCredential: "Credencial de acceso",
  active: "Activo",
  blocked: "Bloqueado",
  phoneMustCointais11Digits: "El teléfono debe contener 11 dígitos",
  CPFMustCointais11Digits: "CPF debe contener 11 dígitos",
  city: "Ciudad",
  remarks: "Observaciones",
  newCollector: "Nuevo Coleccionista",
  // routesToCollect: "Rutas para recopilar",
  closings: "Cierres",
  regionalIdManager: "ID Ger. Regional",
  collector: "Coleccionista",

  agent: "Agente",
  route: "Ruta",
  payCollect: "Pagar / Cobrar",
  noRouteToCollect: "No hay ruta para recopilar",
  summary: "Resumen",
  payable: "pagadero",
  toCollect: "Para recolectar",
  total: "Total",
  newRoute: "Nueva Ruta",
  nameCollector: "Nombre del Coleccionista",
  routeName: "Ruta",
  linkRegional: "Enlace regional",
  selectRegional: "Seleccionar regional",
  // linkAgents: "Agentes de enlaces",
  selectAgents: "Seleccionar Agentes",
  previous: "Anterior",
  users: "Usuarios",
  page: "Página",
  next: "siguiente",
  dtRegistration: "Fecha de Registro",
  cellPhone: "Móvil",
  download: "Descargar",
  actives: "Activos",
  inactives: "Inactivos",
  inactivesPlayersMsg:
    " * Inactivo: Jugadores que no hayan iniciado sesión en los últimos 30 días o que nunca hayan iniciado sesión.",
  noDataForthisQuery: "No hay datos para esta consulta.",
  canPlaceBetsOnline: "Puede realizar apuestas en línea",
  // balance: "Balance",
  factor: "Factor",
  bets: "Apuestas",
  validBets: "Apuestas válidas",
  exemptBets: "Apuestas exentas",
  credit: "Crédito",
  userUnconfirmedAccontMsg:
    "Este usuario aparece con su cuenta no confirmada. Puede reenviar el enlace de confirmación.",
  resentSMS: "Reenviar SMS",
  resentEmail: "Reenviar correo electrónico",
  awardRedemption: "Redención de premios",
  whichAgentIdCanRequest:
    "Aquí puede definir qué ID de agente puede solicitar el usuario (jugador) para canjear sus recompensas.",
  whichAgentIdCanRequestAffiliate:
    "Aquí puede definir con qué ID de agente puede estar afiliado el usuario (jugador)",
  searchAgent: "Buscar un agente",
  defineTheAgent: "Defina el agente (ingrese solo el ID del agente)",
  userLimits: "Límites de usuario",
  realiabilityFactor: "Factor de Confiabilidad",
  newArea: "Área nueva",
  subAreaOf: "Subárea de",
  description: "Descripción",
  promotionDescription: "Descripción *",
  areaName: "Nombre de área",
  areaDescroption: "Descripción del área",
  grouped: "Agrupado",
  list: "Lista",
  qtyBet: "Cant. Apuesta ",
  salesBets: "Apuestas de venta",
  cancelledBets: "Apuestas canceladas",
  coAgentBet: "Co.Agent (apuesta)",
  coAffiliateBet: "Co. Afiliado (apuesta)",
  qtyCredits: "Cantidad. Créditos",
  salesCredits: "Créditos de ventas",
  coAgentCredit: "Co.Agent (Crédito)",
  coGerLocal: "Co. Ger. Local",
  grossProfit: "Beneficio bruto",
  coRegionalManager: "Co. Ger. Regional",
  netProfit: "Ingresos netos",
  qtyAgents: "Cantidad de agentes",
  qtyAffiliates: "Cantidad de afiliados",
  credits: "Créditos",
  coAgentCreditSales: "Co.Agent (Ventas a crédito)",
  coRegionalCreditSales: "Regional Co. (Ventas a crédito)",
  agentName: "Nombre del agente",
  numbersOfAgents: "Número de agentes",
  numberOfAffiliates: "Número de Afiliados",
  commissionRegionalOnGrossProfit:
    "Comisión del Gerente Regional sobre Beneficio Bruto",
  amountBetsSold: "Cantidad de apuestas vendidas",
  bettingSalesValue: "Valor de las ventas de apuestas",
  reverseOfCanceledBets: "Apuestas canceladas inversas",
  agentsCommissiononBettingSales:
    "Comisión del agente sobre las ventas de apuestas",
  amountOFCreditsSold: "Cantidad de créditos vendidos",
  creditSalesAmount: "Credit Sales Amount",
  agentCommissionInfoKey: "Comisión del agente sobre la venta de créditos",
  localManagerCommissionInfoKey:
    "Comisión del administrador local sobre ventas de agentes",
  awardValue: "Valor del premio",
  netProfitResume:
    "El beneficio neto es el beneficio bruto menos la comisión del gerente regional",
  groosProfitResume:
    "La ganancia bruta es el total de ventas menos comisiones y primas",
  launch: "Lanzamiento",
  gerLocal: "Gener Local",
  qty: "Cant.",
  sales: "Ventas",
  balanceReport: "Balance",
  totalBalance: "Total Balance",
  extract: "Extracto",
  extractAgent: "Agente de extracción",
  filter: "Filtro",
  date: "Fecha",
  salesQty: "Cantidad de ventas",
  verified: "Verificado",
  canceled: "Cancelado",
  rights: "Aciertos",
  dayBalance: "Saldo diario",
  finalBalance: "Saldo final",
  noDrivesFount: "No se encontraron unidades.",
  filterFrom: "Filtrar desde",
  category: "Categoría",
  lastPickup: "Última recaudación",
  depostiForPaymentOfPremiums: "Depósito para el pago de la (s) prima (s)",
  miscellaneoutDeposit: "Depósito misceláneo",
  reverse: "Inversión",
  is: "Es para",
  type: "Tipo",
  receiveFromTheAgent: "Recibir del agente",
  payTheAgent: "Pagar al agente",
  launchedBy: "Lanzado por",
  receivedPaid: "Recibido / Pagado",
  received: "Recibido",
  paids: "Pagado",
  TOTAL: "TOTAL",
  releases: "Lanzamientos",
  region: "Región",
  area: "Área",
  amountBet: "Cantidade de apuestas",
  betCanceled: "A. Canceladas",
  regionalCo: "Regional Co.",
  coAgentSalesBets: "Co.Agent (Venta de apuestas)",
  qtyBets: "Cant. de apuestas",
  graphic: "Gráfico",
  news: "Nuevos",
  olds: "Viejos",
  championship: "Campeonato",
  match: "Partido",
  nOfBets: "No. de apuestas",
  simple: "Simple",
  multiples: "Múltiplos",
  lost: "Perdido",
  add: "Agregar",
  combinationAnalysis: "Análisis de combinación",
  exactly: "Exacto",
  combination: "Combinación",
  simulationOnProvider: "Simulación en el Proveedor",
  betAmount: "Monto de la apuesta",
  possibleReturn: "Ganancias Potenciales",
  totalCommission: "Comisión total",
  betting: "Apuestas",
  youtReturnWouldBe: "Tu regreso sería",
  countryLeague: "País / Liga",
  league: "Liga",
  event: "Evento",
  odd: "Cotización",
  filters: "Filtros",
  toFilter: "Filtro",
  country: "País",
  tournament: "Torneo",
  postponed: "Aplazado",
  suspended: "Suspendido",
  thisEventCannotBeCanceled: "¡Este evento no se puede cancelar!",
  thisEventCannotBeSuspended: "¡Este evento no se puede suspender!",
  all: "Todo",
  allowedFieldUpTo100: "Campo permitido hasta el 100%",
  toSelect: "Seleccionar",
  institutional: "Institucional",
  workWithusAndContact: "TRABAJA CON NOSOTROS Y CONTACTA",
  publicContactEmail: "Correo electrónico de contacto público:",
  socialNetWorks: "REDES SOCIALES (OPCIONAL)",
  aboutYourCompany: "ACERCA DE SU EMPRESA",
  tellAboutYourBusiness: "Cuéntele a su audiencia acerca de su negocio:",
  registrationDataBilling: "Datos de registro / Facturación",
  dataResponsible: "RESPONSABLE DE LOS DATOS",
  dataAddress: "DATOS DE DIRECCIÓN",
  number: "Número",
  neighborhood: "Barrio",
  generalSettings: "Configuración general",
  promotions: "Promociones",
  informPromotionsByYourBusiness:
    "Informe a su audiencia de las promociones promocionadas por su empresa:",
  toCancel: "Cancelar",
  billingEmail: "Correo electrónico de facturación",
  addressData: "DATOS DE DIRECCIÓN",

  generalSettingsAgents: "Configuración general - Agentes",
  cancellationOfBetByAgent: "CANCELACIÓN DE APUESTA POR AGENTE",
  cancelBet: "Cancelar apuesta",
  minutesToCancel: "Minutos para cancelar",
  generalSettingsPortal: "Configuración general - Portal",
  portalOptions: "OPCIONES DE PORTAL",
  acceptPreBet: "¿Aceptar apuesta previa?",
  activateLiveModule: "¿Activar módulo en vivo?",
  minutesAllowrdOnLive: "Minutos permitidos en Live",
  generalSettingsBanking: "Configuración general - Banca",
  controlOfLimits: "CONTROL DE LÍMITES",
  numbersOfDaysInTable: "Número de días en la tabla",
  maximumEventsPerBet: "Máximo de eventos por apuesta",
  maximumBankingAward: "Premio bancario máximo",
  minimumBetAmount: "Cantidad mínima de apuesta",
  maximumValueOfBet: "Valor máximo de una apuesta",
  minimumMultiplierForABet: "Multiplicador mínimo para una apuesta",
  maximumMultiplierForABet: "Multiplicador máximo para una apuesta",
  doNotDisplayQuotesBelow: "No mostrar comillas debajo",
  maximumLimitByOptionOnEvent: "Límite máximo por opción en evento",
  maximumLimitByMarketOnEvent: "Límite máximo por mercado en evento",
  percentUserCanHighLimit:
    "Porcent. que el usuario puede utilizar el límite máximo",
  PRINT: "IMPRIMIR",
  observation: "Observación",
  reulationForThePortal: "REGLAMENTO PARA EL PORTAL",
  filterByCountry: "Filtrar por país",
  selectASport: "Seleccionar un deporte",
  noDataFount: "¡No se encontraron datos!",
  selectAMarket: "Seleccionar un mercado",
  preGame: "Pre-Game",
  Live: "En Vivo",
  oddMax: "Odd Max",
  recommendedImagiSizeBanner:
    "Las proporciones recomendadas para la imagen del banner son: 3:1 (p. ej.: 900x300px, 1200x400px) hasta 5:2 (p. ej.: 1500 x 600px, 1000 x 400px), en formatos de archivo .png o .jpg con un máximo de 2MB. Al cargar imágenes, procure enviarlas siempre en la misma proporción.",
  recommendedImagiSizeParner:
    "Tamaño de imagen recomendado para Socios, licencias, métodos de pago 100x100 píxeles (.png, .jpg o .gif) con máx. de 1Mb.",
  recommendedImagiSizePopup:
    "Tamaño de imagen recomendado para Pop-up 512x512 píxeles (.png, .jpg o .gif) con un máximo de 1Mb.",
  recommendedImagiSizePromoImage:
    "Tamaño de imagen recomendado 1800x700 píxeles (.png o .jpg) con un máximo de 1Mb.",
  recommendedImagiSizeMenu:
    "Tamaño de imagen recomendado para Menu ancho 300px con altura relativa (.png, .jpg o .git) con un máximo de 1Mb.",
  selectABanner: "Seleccionar un banner:",
  addBanner: "Agregar banner",
  errorDeletingImage: "Se produjo un error al eliminar tu imagen:",
  chooseAnImageFirst: "Por favor, elija una imagen primero",
  imageTooLarge: "Imagen demasiado grande (2 MB máximo)",
  fileTypeNotAllowed:
    "¡Tipo de archivo no permitido! Solo se permiten .png, .jpg o .gif",
  fileTypeNotAllowedImage:
    "¡Tipo de archivo no permitido! Solo se permiten .png o .jpg",
  maximum6Images: "Máximo 6 imágenes.",
  bannerSentsuccessfully: "Banner enviado correctamente",
  errorUploadingBanner: "Se produjo un error al cargar su banner:",
  banners: "Banners",
  partners: "Socios",
  license: "Licencia",
  toView: "Ver",
  sgaNotifications: "Notificaciones SGA",
  yourNotifications: "Sus notificaciones",
  subject: "Asunto",
  noSubject: "Sin asunto",
  read: "leído",
  notRead: "No leído",
  toActive: "Activar",
  toDisable: "Desactivar",
  toSend: "Enviar",
  openInvoice: "Factura abierta",
  payment: "paga",
  dueDate: "Expiration",
  interest: "Interés",
  pay: "Paga",
  seccondCopy: "Segunda copia",
  ticket: "boleto",
  period: "Periodo",
  plan: "Plano",
  amountTotal: "Valor Total",
  errorGeneratingDuplicate: "Error al generar duplicado",
  enterYourCurrentPassword: "Ingrese su contraseña actual",
  currentPassword: "Contraseña actual",
  enterANewPassword: "Ingrese una nueva contraseña",
  newPassword: "Nueva contraseña",
  enterPasswordHinit:
    "Ingrese una contraseña de 8 caracteres que contenga letras y números",
  confirmNewPassword: "Confirmar nueva contraseña",
  inputRequired: "Este campo es obligatorio",

  generalSettingsTransactions: "Configuración general - Transacciones",
  minimumDepositAmount: "Cantidad mínima de depósito",
  depositFee: "Tarifa de depósito",
  maximumWithdrawalValue: "Valor máximo de retiro",
  minimumWithdrawalAmount: "Cantidad mínima de retiro",
  withdrawalRate: "Tarifa de retiro",
  minBonusBetMultiplier: "Multiplicador de apuesta de bonificación mínima",
  minMetaBonusMultiplier: "Meta multiplicador de bonificación mínima",
  percentageOfBonus: "Porcentaje de Bonificación *",
  maximumBonusAmount: "Cantidad máxima de bonificación",
  solicitedBonus: "Bonificación Solicitada",
  cosolidatedBonus: "Bonificación Consolidada",
  cancelledBonus: "Bonificación Cancelada",
  bonusID: "ID de bonificación",
  requisted: "Solicitado",
  registered: "Registrado",
  consolidated: "Consolidado",
  didCancelled: "Cancelado",
  deposits: "Depósitos",
  withdrawals: "Retiros",
  user: "Usuario",
  amountOfDeposits: "Cantidad de depósitos",
  amountOfWithdrawals: "Cantidad Retiros",
  authorized: "Autorizado",
  depositID: "ID de depósito",
  deposit: "Depósito",
  withdrawalID: "Id. de retiro",
  authorization: "Autorización",
  phone: "Teléfono",
  randomKey: "Clave aleatoria",
  consolidatedValue: "Valor consolidado",
  authorizePayment: "Authorize Payment",
  userID: "ID de Usuario",
  toConfirm: "Confirmar",
  confirmWithdrawalAuthorization: "¿Confirmar autorización de retiro?",
  authorizeWithdrawal: "Autorizar retiro",
  commissionRegionalOnGrossGGR: "Comité de Gerentes Regionales de la GGR.",
  revenues: "Facturación",
  valueOnSoldBets: "Valor en apuestas vendidas",
  valueInAwards: "Valor en premios",
  ggrExplanation:
    "GGR es el monto de facturación restando el monto de la prima.",
  feeGGRPercentageExplanation: "Cargo por servicio aplicado sobre el GGR.",
  valueNGRExplanation:
    "Neto después de la aplicación de las tarifas de servicio.",
  agentCommissionExplanation: "Comisión del agente en el GGR",
  affiliateCommissionExplanation: "Comisión del afiliado en el GGR",
  localCommissionExplanation: "Comisión del Gerente local sobre GGR",
  valuesFinancial: "Valores financieros",
  awarded: "Premiado",
  quantities: "Cantidades",
  AmountLostBets: "Cantidad de apuestas perdidas",
  amountAwarded: "Cantidad Premiadas",
  pendings: "Pendiente",
  amountPending: "Cantidad pendientes",
  betsAmount: "Cantidad de apuestas",
  bonusBet: "Apuesta de bonificación",
  maximumInstantWithdrawalValue: "Valor máximo de retiro instantáneo",
  minimunDepoistAmount: "Cantidad mínima de depósito",
  minimumMultiplierToGoalBonus:
    "Multiplicador mínimo para alcanzar la meta y canjear el bono",
  percentageOnDeposit: "Porcentaje sobre depósitos",
  maximumValueOfWithdrawal: "Valor máximo de un retiro",
  minimumValueOfWithdrawal: "Valor mínimo de un retiro",
  percentageOnWithdrawals: "Porcentaje sobre retiros.",
  percentageOfBonusOperator:
    "Porcentaje de bonificación establecido por el banco",
  limitMaximumAmountBonus: "Limita la cantidad máxima de bonificaciones",
  minimulMultiplerForBettingBonus:
    "Multiplicador mínimo para apostar con saldo de bonificación",
  maximumValueUserWithdrawInstantly:
    "Valor máximo que un usuario puede dibujar instantáneamente",
  affiliates: "Afiliados",
  affiliate: "Afiliado",
  nameAffiliate: "Nombre Afliado",
  searchAffiliateSpan:
    "Buscar por ID, nombre, inicio de sesión o correo electrónico de su afiliado",
  findAnAffiliate: "Encontrar un afiliado",
  singleAffiliate: "Solo afiliado",
  players: "Jugadores",
  depositsAndWithdrawals: "Depósitos y Retiros",
  promotionLabelBonus: "Bonificación *",
  bonus: "Bonificación",
  configuration: "Configuración",
  accountability: "Rendición de Cuentas",
  account: "Cuenta",
  reports: "Informes",
  system: "Sistema",
  listBets: "Lista de apuestas",
  listCredits: "Lista de crédito",
  playersList: "Lista de jugadores",
  inactivePlayers: "Jugadores inactivos",
  extractByUser: "Extracto por usuario",
  betsPDV: "Apuestas PDV",
  historic: "Histórico",
  regionalManagers: "Gerentes Regionales",
  // newRegionalManager: "Nuevo gerente regional",
  editRegionalManager: "Editar administrador regional",
  localManagers: "Gerentes Locales",

  editLocalManager: "Editar Gerente local",
  editAgent: "Editar agente",
  agentBettingCommision: "Comisiones - Rango De Eventos",
  collectors: "Coleccionistas",
  editCollector: "Editar Coleccionista",
  routes: "Rutas",
  editRoute: "Editar ruta",
  listAreas: "Listar áreas",
  editArea: "Área de edición",
  eventsBetting: "Eventos de apuestas",
  defense: "Defensa",
  generalFinding: "Apuración General",
  areaFinding: "Apuración Area",
  routesFinding: "Apuración de Rutas",
  agentRelease: "Liberación del agente",
  balanceByRoute: "Balance por Ruta",
  editOdd: "Editar Odd",
  bankConfiguration: "Configuración del banco",
  manageLeagues: "Administrar ligas",
  marketsAndMargins: "Mercados y márgenes",
  manageMedia: "Administrar media",
  notifications: "Notificaciones",
  notification: "Notificaciones",
  invoices: "Facturas",
  invoice: "Factura",
  agents: "Agentes",
  historyLocalBettingManager: "Historial del Gerente Local de apuestas",
  balancePerRoute: "Balance por ruta",
  cashCollector: "Cobro en efectivo",
  newRelease: "Nueva versión",
  collectorReport: "Informe del Coleccionista",
  agentCreditHistory: "Historial crediticio del agente",
  agentsList: "Lista de agentes",
  enterCurrentPassword: "Ingrese su contraseña actual",
  labelCurrentPassword: "Contraseña actual",
  labelNewPassword: "Nueva contraseña",
  hintNewPassword:
    "Ingrese una contraseña de 8 caracteres que contenga letras y números.",
  btnChangePassword: "Cambiar contraseña",
  rulesPassMatch: "Este campo es obligatorio.",
  rulesRepeatPassword: "Repetir contraseña",
  labelLogin: "Acceso",
  printDate: "Día y hora de impresión:",
  btnPrint: "Imprimir",
  labelSearch: "Buscar",
  itemsPerPage: "Filas por página",
  justResume: "Resumen",
  localManagerId: "ID Ger. Local",
  localManagerName: "Ger. Local",
  agentId: "ID Agente",
  headersAgentName: "Agente",
  grossValue: "Ingresos",
  prizeValue: "Premios",
  valueGGR: "Ingresos brutos del juego",
  valueGGRProjected: "Receta (Saldo En Línea)",
  agentCommission: "Comisión del agente",
  affiliateCommission: "Comisión del afiliado",
  localManagerCommission: "Ger. Local. Comisión",
  regionalManagerCommission: "Ger. Regional Comisión",
  qtdAgents: "Cant. Agentes ",
  infoAgentName: "Nombre del agente",
  infoAffiliateName: "Nombre del afiliado",
  infoQtdAgent: "Canti. de agentes",
  qtdBets: "Canti. de Apuestas",
  infoGrossValue: "Valor en apuestas vendidas",
  infoPrizeValue: "Valor en premios",
  infoValueGGR: "GGR es el monto de facturación restando el monto de lo premio",
  infoAgentCommission: "Comisión de los agentes en la GGR",
  infoLocalCommission: "Comisión de los Gerentes Locales de la GGR",
  infoRegionalCommission: "Comisión Regional de los Gerentes de la GGR",
  editedEvent: "Evento Editado",
  valorSome: "Valor_some",
  idLabel: "ID",
  infosLabel: "Información",
  eventsLabel: "Eventos",
  dateLabel: "Fecha/Hora",
  valueLabel: "Valor",
  returnLabel: "Ganancias",
  resultLabel: "Resultado",
  paidLabel: "Pagado",
  actionsLabel: "Acciones",
  paidPrizes: "Premios Pagados",
  possiblePrizes: "Posibles premios",
  extractLabel: "Extracto",
  releaseLabel: "Lanzamiento",
  releasesLabel: "Lanzamientos",
  collectorExtract: "Declaración del Coleccionista",
  collectorLabel: "Coleccionista",
  routesToCollect: "Rutas para recoger",
  codeLabel: "Código",
  categoryLabel: "Categoría",
  statusLabel: "Estado",
  remainingBalance: "Balance restante",
  agentStatement: "Declaración del agente",
  totalReceivedFromManager: "Total recibido del gerente",
  totalPaidToAgent: "Total pagado a los agentes",
  totalReceivedFromAgent: "Total recibido de los agentes",
  finalBalanceLabel: "Saldo final",
  consolidateAndRegisterInCash: "consolidar y registrar en efectivo",
  regionalFinancialBox: "Caja Financiera Regional",
  pediodAfterLastCollection: "Periodo posterior a la última colección",
  newLaunch: "Nuevo Lanzamiento",
  receivedLabel: "Recibido",
  paidLabelCollector: "Pagado",
  notConsolidated: "No consolidado",
  isConsolidated: "Consolidado",
  prizeDepositPayment: "Depósito para el pago de premios",
  miscellaneousDeposit: "Depósitos varios",
  chargeback: "Contracargo",
  filterByDate: "Filtrar por fecha",
  previousBalance: "Saldo anterior",
  commissionSales: "Comisión",
  cancellations: "Cancelaciones",
  canceledBets: "Apuestas canceladas",
  deals: "Aciertos",
  countSales: "Ventas totales",
  balance: "Saldo",
  qtdLabel: "Cant.",
  releasesPaid: "Pagos",
  releaseReceived: "Recibidos",
  totalLabel: "Total",
  releasedBy: "Lanzado por",
  btnFilter: "Filtrar",
  agentLabel: "Agente",
  periodLabel: "Curso del tiempo:",
  dailyBalance: "Saldo diario",
  dateHeader: "Fecha",
  extractAgentAlert: "No se encontraron transacciones financieras",
  to: "Para",
  balanceLabel: "Saldo",
  launchType: "Tipo",
  receiveFromAgent: "Recibir del agente",
  payToAgent: "Pago al agente",
  btnSave: "Guardar",
  valueEntryRules: "Este campo es obligatorio",
  userLabel: "Usuario",
  revenueLabel: "Ingresos",
  agentsComissionsLabel: "Comisiones de los agentes",
  qtdSalesCredit: "Cant. Créditos de ventas",
  qtdCredit: "Cant. Crédito",
  creditSales: "Ventas a crédito",
  salesCreditCommi: "Comisiones de ventas a crédito",
  agentBetCommission: "Comisión del agente (apuestas vendidas)",
  agentCreditCommission: "Comisión del agente (crédito)",
  localManagerCommiGross: "Comisiones de gerentes locales (bruto)",
  regionalManagerCommiLiquid: "Comisión de Gerente Regional (Netos)",
  betsLabel: "Apuestas",
  soldBets: "Apuestas Vendidas",
  fullCollection: "Colección completa",
  totalDepositPremiumPayment: "Depósito total para pago de prima",
  totalMiscellaneousDeposit: "Depósito misceláneo total",
  totalChargeback: "Inversión total",
  collection: "Colección",
  miscellaneouDeposit: "Depósito misceláneo",
  msgFeedBackSetCash: "Descripción de más de 80 caracteres",
  accounting: "Contabilidad",
  retention: "Retencion",
  registrationDate: "Fecha de Registro",
  unlimitedLabel: "Ilimitado",
  unlimited: "ILIMITADO",
  localManagerLabel: "Gerente Local",
  fullNameLabel: "Nombre completo",
  cpfLabel: "CPF",
  emailLabel: "Correo Electrónico",
  cellphoneOneLabel: "Teléfono móvil 1",
  cellphoneTwoLabel: "Teléfono móvil 2",
  cepLabel: "CEP",
  addressLabel: "Dirección",
  stateLabel: "Estado",
  cityLabel: "Ciudad",
  commentsLabel: "Observaciones",
  limitsLabel: "Limites",
  valuePerMatchSingleBet: "Valor por partido (en apuesta única)",
  dailyBetLimit: "Límite diario de apuestas",
  settingsLabel: "Ajustes",
  activateLiveLabel: "Activar Live",
  viewAwardees: "Ver premios",
  accessCredential: "Credenciales de acceso",
  passwordLabel: "contraseña",
  openRegister: "abre el cajero",
  alertRouteCollect: "No hay rutas para recopilar",
  toPay: "A pagar",
  routeLabel: "Rutas",
  selectRoutes: "Seleccionar rutas",
  newLocalManager: "Nuevo Gerente Local",
  routeNameLabel: "Nombre de ruta",
  linkAgents: "Vincular agentes",
  schedule: "Calendario",
  client: "Cliente",
  selection: "Selección",
  market: "Mercado",
  conference: "Conferencia",
  printingTime: "Tiempo de impresión",
  prohibitedForUnder18: "Prohibido para menores de 18 años",
  double: "Par",
  triple: "Triple",
  multiple: "Multiple",
  wantCancelTheBet: "Realmente quiero cancelar la apuesta",
  betConference: "CONFERENCIA DE APUESTAS",
  noValidForAwardReceipt: "(NO VÁLIDO PARA RECIBO DE PREMIO)",
  reverseAmount: "Importe inverso",
  right: "Acerto",
  refund: "Reembolso",
  missed: "Perdido",
  betCod: "Apuesta cod.",
  datas: "Datos",
  noRouteLinked: "Sin ruta vinculada",
  noAgentLinked: "Ningún agente vinculado",
  update: "Actualizar",
  submitBetId: "¡Enviar ID de apuesta!",
  toClose: "Cerrar",
  localManager: "Gerente local",
  searchPlayers: "Buscar jugadores",
  searchPlayer: "Buscar jugador",
  seachPlayersMsg: "Buscar por ID, nombre, acceso, teléfono o Email",
  dateRange: "Intervalo de fechas",
  toClean: "Limpiar",
  terminal: "Terminal",
  general: "General",
  breaks: "Descansos",
  today: "Hoy",
  yesterday: "Ayer",
  lastMonth: "El mes pasado",
  currentWeek: "Esta semana",
  lastWeek: "La semana pasada",
  lastSevenDays: "Últimos 7 días",
  halfMonth: "Últimos 15 días",
  currentMonth: "Mes actual",
  invalidTime: "Hora no válida",
  weeklyCalculation: "Cálculo semanal",
  currentCalculation: "Cálculo actual",
  paidAndReceiverFromAgent: "Pagado y recibido del agente",
  onlyReceivedFromAgent: "Solo 'Recibido' del agente",
  onlyPaitToTheAgent: "Solo 'Pagado' al agente",
  losts: "Perdido",
  didSuspended: "Suspendido",
  doActives: "Activo",
  cancelleds: "Cancelado",
  statusEvent: "Estado del evento",
  cancelledsMasc: "Cancelado",
  depositRequested: "Depósito solicitado",
  depositConsolidated: "Depósito consolidado",
  depositCancelled: "Depósito cancelado",
  withdrawalRequisted: "Retiro solicitado",
  withdrawalAuthorized: "Retiro autorizado",
  withdrawalConsolidated: "Retiro consolidado",
  withdrawalCancelled: "Retiro cancelado",
  bonusCancelled: "Bonificación cancelada",
  bonusRequested: "Bonificación solicitada",
  bonusConsolidated: "Bonificación consolidada",
  byValue: "Por Valor",
  exactValue: "Valor exacto:",
  valueGreaterThan: "Valor mayor que:",
  valueLessThan: "Valor menor que:",
  consultBet: "Consultar Apuesta",
  network: "Red",
  weeklyCalculationReport: "Informe de cálculo semanal",
  currenccalculationReport: "Informe de cálculo actual",
  report: "Informe",
  copySuccessfully: "¡Copia correctamente!",
  unexpectedErrorOccured:
    "Se produjo un error inesperado, inténtelo de nuevo más tarde",
  notStarted: "No iniciado",
  inProgress: "En progreso",
  documentInAnalysis: "Em Análise",

  finished: "Terminado",
  didPostponed: "Pospuesto",
  interrupted: "Interrumpido",
  abandoned: "Abandonado",
  closeToStart: "Cerrar para comenzar",
  pageNotFound: "Página no encontrada",
  comeBack: "Volver",
  _homePage: "Página de inicio",
  byUser: "Por usuario",
  readQRcodeToPayPIX:
    "Para realizar el pago mediante foto, lea el código Qr en la aplicación de su banco o haga clic en el botón para copiar el código.",
  depositAmount: "Importe del depósito",
  or: "o",
  repeatThePassword: "La confirmación debe ser la misma que la contraseña.",
  darkTheme: "Tema oscuro",
  administrator: "Administrador",
  reasonFroCancellation: "Motivo de la cancelación",
  reason: "Razón",
  bet: "Bet",
  witdhdrawalAuthorized: "Autorización de retiro",
  FilteredPeriod: "Período filtrado",
  seller: "Vendedor",
  comissionGerLocal: "Comisión del Gerente Local (bruta)",
  coAgent: "Com. Agente",
  agentCommissions: "Comisiones de los agentes",
  assessment: "Evaluación",
  oddMargin: "Margen Odd",
  currentCredit: "Crédito actual",
  retentionLimit: "Límite de retención",
  rowsPerPage: "Líneas por página:",
  linkedRoutes: "Rutas vinculadas",
  linkedAgents: "Agentes Vinculados",
  requiredInput: "Campo obligatorio *",
  allowPixKeyEdit: "Permitir edición de clave Pix",
  linkRoute: "RUTA DE ENLACE",
  searchByMarket: "Pesquisar por mercado",
  punter: "Jugador",
  userModifyPixkey: "Permitir al usuario modificar su clave de imagen",
  pixKey: "PIX KEY",
  removeTrack: "Eliminar pistas",
  remove: "Eliminar",
  addNewTrack: "Agregar nueva pista",
  searchToMarket: "Buscar por mercado",
  makeDeposit: "Realizar depósito",
  notRegisteredEmail: "Correo electrónico no registrado",
  local: "Local",
  regional: "Regional",
  qtySales: "Cant. Ventas",
  eventsPerBetHint:
    "Para suspender las actividades de apuestas, ingrese el valor 0.00 en este campo",
  maximumLimitByMarketOnEventTip:
    "Esta configuración se aplica para definir cuánto puede soportar cada mercado de un evento en las apuestas en línea.",
  percentUserCanHighLimitTip:
    "Este porcentaje se aplica solo a los usuarios en línea, sirve para limitar cuánto puede usar cada usuario el límite máximo.",
  disabled: "Discapacitado",
  groosProfit: "Beneficio bruto",
  accountDrawer: "Cuenta ",
  salesLimit: "Límite de ventas",
  originalTimeOdds:
    "Tiempo para validar apuesta con cuotas originales (minutos)",
  originalTimeOddsTip:
    "Aceptar cambios de cotización entre la pre-apuesta y la validación del agente.",
  valueMinAccepted: "El monto mínimo para las apuestas es $ 0.50",

  // invoice: "FACTURA",
  invoiceNum: "Factura Nº: ",
  invoiceUseLicense: "SGA.BET - Licencia de uso",
  invoiceDesctiption:
    "Discriminación: la renovación de su plan es mensual, según pago de la factura aquí presentada.",
  invoiceServiceProvider: "Proveedor de servicio:",
  invoiceBill: "Facturar a cuenta",
  invoiceAccNumber: "Número de cuenta:",
  invoiceClient: "Cliente:",
  invoiceDomain: "Dominio:",
  invoiceAddress: "Dirección:",
  invoiceCityState: "Ciudad/Estado:",
  invoiceZipcode: "Código postal:",
  invoiceDateStart: "Fecha de inicio",
  invoiceDateEnd: "Fecha de finalización",
  invoicePlanDescription: "Descripción del plan",
  invoiceTotalPrice: "Precio Total ($)",
  invoiceSubTotal: "Total parcial",
  invoiceAddition: "Adición",
  invoiceDiscount: "Descuento",
  invoiceObservation: "Observación:",
  invoiceThankYou: "¡Gracias por su preferencia!",
  invoiceProductCompany:
    "SGA.BET © Un producto de la empresa TITANS SOFTWARE CORP.",
  unpaidAwards: "Premios no pagados",
  idOperation: "ID de Operación",
  consultByRegistrationDate: "Consulta por Fecha de Registro",
  byDeposit: "Por Depósito",
  byBalance: "Por Saldo",
  exactBalance: "Saldo exacto",
  balanceGreaterThan: "Saldo mayor que:",
  balanceLessThan: "Saldo menos de:",
  inactive: "Inactivo",
  qtyDeposits: "Canti. de depósitos",
  exactQty: "Cant. exacta",
  QtyGreaterThan: "Cant. Mayor que:",
  QtyLessThan: "Cant. menos de:",
  realiabilityFactorTip:
    "Este factor sirve como multiplicador del porcentaje que este usuario puede utilizar en cada mercado, porcentaje que se define en la configuración del banco.",
  playerAffiliation: "Afiliación del jugador",
  marketLimits: "Límites de mercado",
  byAward: "Por Premio",
  exactAward: "Premio exacto",
  awardGreaterThan: "Premio mayor que:",
  awardLessThan: "Premio menor que:",
  consultLogs: "Consultar Logs",
  byTypeOfUser: "Filtrar por tipo de usuario",
  backOffice: "Backoffice",
  logLegend: "Al encontrar datos, se realizará una descarga automática.",
  filterAction: "filtrar la acción",
  inputStringLabel: "Ingrese un acceso",

  // LOGS
  accountBlocked: "Cuenta Bloqueada",
  accountSuspended: "Cuenta Suspendida",
  admPasswordUpdated: "Contraseña de ADM Actualizada",
  agentCreditAdded: "Crédito de Agente Agregado",
  agentCreditReseted: "Restablecimiento del Crédito del Agente",
  agentInserted: "Agente Insertado",
  agentPasswordUpdated: "Contraseña del Agente Actualizada",
  agentRoutesInserted: "Rutas de Agente Insertadas",
  agentRoutesUpdated: "Rutas de Agentes Actualizadas",
  agentStatusChanged: "El Estado del Agente Cambió",
  agentStatusUpdated: "Estado del Agente Actualizado",
  agentUpdated: "Agente Actualizado",
  areaInserted: "Área Insertada",
  areaUpdated: "Área Actualizada",
  betCanceledLog: "Apuesta Cancelada",
  betPaid: "Apuesta Pagada",
  betPaidByAdm: "Apuesta Pagada Por El ADM",
  betValidated: "Apuesta Validada",
  bonusChanged: "Bonificación Modificada",
  cashoutAuthorizedByAdm: "Retiro Autorizado de ADM",
  collectorConsolidatedCash: "Caja Colectora Consolidada",
  collectorEntryInserted: "Entrada de Recopilador Insertada",
  collectorRoutesInserted: "Rutas de Recopilador Insertadas",
  collectorUpdated: "Recopilador Actualizado",
  commissionsUpdated: "Comisiones Actualizadas",
  cambiadoUserStatus: "Estado de Usuario Modificado",
  creditCanceled: "Crédito Cancelado",
  creditSold: "Crédito Vendido",
  depositForPlayerBillet: "Billete para Depósito del Jugador",
  depositOnline: "Depósito en Línea Paybrokers",
  depositOnlinePay4Fun: "Depósito en Línea Pay4Fun",
  depositOnlineBrasilCash: "Depósito en Línea Brasil Cash",
  entryDealInserted: "Acuerdo de Entrada Insertado",
  eventCanceled: "Evento Cancelado",
  eventMarketChanged: "Mercado de Eventos Cambiado",
  eventOutcomeUpdated: "Resultado del Evento Actualizado",
  eventStatusChanged: "El Estado del Evento Cambió",
  invalidLevel: "Nivel no Válido",
  localInserted: "Lugar Insertado",
  localManagerInserted: "Administrador Local Insertado",
  localManagerUpdated: "Administrador Local Actualizado",
  localManagerPasswordUpdated: "Contraseña Gerente Local Actualizada",
  localUpdated: "Local Actualizado",
  loginSuccess: "Inicio de Sesión Exitoso",
  marketInserted: "Mercado Insertado",
  operatorConfigUpdated: "Configuración del Operador Actualizada",
  operatorOnlineConfigUpdated:
    "Configuración en Línea del Operador Actualizada",
  resultsInserted: "Resultados Insertados",
  resultUpdated: "Resultado Actualizado",
  placeBet: "Hacer Apuesta",
  playerAddressDataUpdated: "Datos de Dirección del Jugador Actualizados",
  playerBankDataUpdated: "Datos Bancarios del Jugador Actualizados",
  playerContactDataUpdated: "Datos de Contacto del Jugador Actualizados",
  playerInserted: "Jugador Insertado",
  playerInstantCashout: "Retiro Instantáneo del Jugador",
  playerPasswordUpdated: "Contraseña del Jugador Actualizada",
  playerPersonalDataUpdated: "Datos Personales del Jugador Actualizados",
  playerUpdated: "Jugador Actualizado",
  preBetLog: "Pre-apuesta",
  insertedRegional: "Regional Insertado",
  regionalPasswordUpdated: "Contraseña Regional Actualizada",
  regionalUpdated: "Regional Actualizado",
  incompleteRegistration: "Registro Incompleto",
  tournamentEntered: "Torneo Ingresado",
  userUpdated: "Usuario Actualizado",
  withdrawIntention: "Intención de Retiro",
  wrongPassword: "Contraseña Incorrecta",
  collectorInserted: "Colector Insertado",
  outcomesInserted: "Opción de Mercado Insertada",
  outcomeUpdated: "Valor de Opción de Mercado Actualizado",
  userStatusUpdated: "Estado de Usuario Actualizado",
  legendInactiveAgents:
    "Agentes que No han Realizado una Apuesta en los Últimos 30 Días",
  updatedCommissions: "Comisiones Actualizadas",

  actionsContributors: "Acciones del Usuario",
  // Actions Contributors
  logIntoTheSystem: "Iniciar sesión en el sistema",
  listBetsWinningLosingPending:
    "Lista de apuestas, ganhadoras, perdidas, pendientes",
  cancelBets: "Cancelar apuestas",
  listAgents: "Listar agentes",
  activateSuspendConsultAgents: "Crear / Editar / Consultar agentes",
  activateSuspendAgents: "Activar / Suspender agentes",
  listLocalManagers: "Lista de administradores locales",
  createEditQueryLocal: "Crear / Editar / Consultar administradores locales",
  activateSuspendLocal: "Activar / Suspender administradores locales",
  createEditQueryRoutes: "Crear / Editar / Consultar rutas",
  listCollectors: "Lista de recopiladores",
  createEditConsultCollectors: "Crear / Editar / Consultar recopiladores",
  viewAgentNetworkFinancial:
    "Vizualizar los informes financieros de su red de agentes, ventas, comisiones, primas pagadas, brutas, netas",
  viewFinancialStatements:
    "Vizualizar estados financieros, ajustes realizados con cobradores y agentes",
  viewAffiliateReports: "Vizualizar informes de afiliados",
  makeAdjustmentsAndConsolidateThem: "Realizar ajustes y consolidarlos",
  accessToTheGeolocationOfAgents:
    "Acceso a la geolocalización de agentes en su red",
  noteSomeActionsMayDepend:
    "Nota: Algunas acciones pueden depender de la configuración aplicada a cada usuario",
  viewYourAgentFinancialReport:
    "Vizualizar los informes financieros de su red de agentes, ventas, comisiones, primas pagadas, brutas, netas",
  listCreditSales: "Lista de ventas a crédito",
  changeYourPassword: "Cambia tu contraseña",
  viewFinancialReportsAgent:
    "Vizualizar sus informes financieros, ventas, comisiones, primas pagadas",
  validateVisitorBets:
    "Validar las apuestas de los visitantes, lo que llamamos apuestas previas",
  placeDirectBets: "Realizar apuestas directas",
  sellAndListCreditSales: "Vender y enumerar ventas a crédito",
  accessEventTable: "Acceder a la tabla de eventos",
  accessToAWeeklySummary:
    "A través de la web, acceso a un resumen semanal (panel)",
  AffiliatePlayers: "Jugadores afiliados",
  registerCustomers: "Registrar clientes",
  consultTheRoutesToCollect: "Consulta las rutas para recopilar",
  consultTheFinancialHistoryOfLinkedAgents:
    "Ver el historial financiero de los agentes vinculados",
  performEntriesPayOrReceive: "Realizar entradas, pagar o recibir",
  consultEntriesMadeByManager:
    "Consulta de entradas realizadas por el administrador",
  actionsRegionalCanPerform: "Acciones que puede realizar el Gerente Regional:",
  actionsLocalCanPerform: "Acciones que puede realizar el Administrador local:",
  actionsAgentCanPerform: "Acciones que el Agente puede realizar:",
  actionsCollectorCanPerform: "Acciones que puede realizar el Recopilador:",
  affiliatePlayers: "Afiliar jogadores",
  activeSuspendConsultAgents: "Criar / Editar / Consultar agentes",
  betPlacedReport: "Informe de apuestas realizadas",
  preMatch: "Pre-evento",
  matchDay: "Día del Evento",
  prematchAndMatchday: "Pre-evento / Día del Evento",
  eventDate: "Fecha del Evento",
  totalOdds: "Total Odds",
  idBet: "ID de apuesta",
  cancellation: "Cancelación",
  betDate: "Fecha de apuesta",
  reportAllMarkets: "Relatório de todos os mercados",
  totalBets: "Total de apuestas",
  totalPrize: "Total de premios",
  totalCanceled: "Total cancelado",
  totalCommissions: "Total Comisiones",
  selectCountry: "Seleccione un país",
  suspendEvent: "Suspender evento",
  cancelEvent: "Cancelar evento",
  postponeEvent: "Posponer evento",
  activateEvent: "Activar evento",
  editOdds: "Editar odds",
  opening: "Abrir",
  closing: "Cierre",
  weHaveNoBetsOnThisEvent: "No tenemos apuestas en este evento",
  allMarketsReport: "Informe de todos los mercados",
  noBetsFountForThisEvent: "No se encontraron apuestas para este evento.",
  commissionOnTheGross: "Comisión sobre el bruto",
  commissionOnTheNgr: "Comisión de la NGR",
  commissionType: "Tipo de comisión",
  suspensionDetails: "Detalles de Suspensión",
  suspensionDate: "Fecha de suspensión",
  suspendedBy: "Suspendido por",
  PromotionsAndbonus: "Promociones y Bonificaciones",
  dateStart: "Fecha de inicio",
  dateFinal: "Fecha de finalización",
  timeFinal: "Hora de finalización",
  limitUse: "Límite de uso",
  porcentaje: "Porcentaje",
  PromotionCode: "Código de promoción *",
  createNewPromotion: "Crear promoción",
  registerNewPromotion: "Registrar nueva promoción",
  endTime: "Hora de finalización",
  typeOfPromotion: "Tipo de promoción",
  typeOfPromotionSelect: "Tipo de promoción *",
  register: "Registro",
  noSpacesAreAllowed: "No se permiten espacios",
  dateStartGreaterThanEndDate:
    "La fecha de inicio no puede ser mayor que la fecha de finalización",
  doYouWantToDeactivateThisPromotion: "¿Desea desactivar esta promoción?",
  campaing: "Campaña",
  campaings: "Campañas",
  noCode: "Sin código",
  numberShouldBeGreaterThanZero: "El número debe ser mayor que cero!",
  showOrderOptional: "Orden de aparición (Optional)",
  insertLinkOptional: "Insertar el Link (Optional)",
  disablePromotion: "Deshabilitar promoción",
  campaign: "Campaña",
  newCampingMessage:
    "*El usuario solo puede participar en una promoción de registro, y la promoción de Afiliado anula la promoción de Registro cuando está activa en el mismo período. Para Campañas, use nombres diferentes.",
  usageDetails: "Detalles de uso",
  usageAmount: "Cantidad de uso",
  numberOfUses: "Número de usos",
  promotionTotalBonus: "Total de bonificación de promoción",
  numberOfAvailableUses: "Número disponibles  ",
  maximumNumberOfUses: "Número máximo de usos",
  totalBonusAmountAwarded: "Cantidad total de bonificación otorgada",
  unitaryValue: "Valor unitario",
  newAffiliate: "Nuevo Afiliado",
  linkAffiliate: "Vincular Afiliado",
  casino: "Casino",
  transactions: "Transaciones",
  game: "Juego",
  cancel: "Cancelar",
  choosePlayerToApplyBonus: "Elige jugador para aplicar bono",
  gameType: "Tipo de Juego",
  tableGames: "Juegos de Mesa",
  provider: "Proveedor",
  casinoSettings: "Configuraciones del Casino",
  selectActiveGames: "Elegir Juegos Activos",
  sport: "Deporte",
  sports: "Deportes",
  createBonus: "Crear Bonos",
  registerNewBonus: "Regístra nuevo bono",
  percentageCashOut: "Porcentaje de retiro",
  cashOut: "Retiro",
  bonusSettings: "Configuración de Bonificación",
  transactionsSettings: "Configuración de Transacciones",
  onMaintenance: "Sitio web en mantenimiento",
  onMaintenanceMessage:
    "Para servirle mejor, estamos en mantenimiento. Por favor, inténtelo de nuevo más tarde",
  overview: "Visión general",
  landingPage: "Página de Destino",
  makeYourLandingPage: "Cree su página de destino en el editor abajo.",
  useOurTemplate: "Usar nuestra plantilla como punto de partida:",
  loadTemplate: "Cargar Plantilla",
  previewPage: "Ver Página",
  attention: "Atención",
  cancelPaidBetTitle: "Cancelar Apuesta Pagada",
  cancelPaidBetContent1:
    "Esta apuesta ya ha sido pagada, ¿de verdad quieres cancelarla?",
  cancelPaidBetContent2:
    "Cuando una apuesta ya está pagada, la apuesta se invierte y se deduce el monto del premio. Para ello es necesario acreditar que el jugador tenía saldo a debitar.",
  areYouSureYouWantToCancelTheBonus: "Seguro que quieres cancelar el bono?",
  cancelBonus: "Cancelar bono",
  exactDepositValue: "Depósito exacto",
  moreThanDepositValue: "Depósito mayor que:",
  lessThanDepositValue: "Depósito menos de:",
  byDepositValue: "Por Valor de Depósito",
  duo: "Par",
  changeOutcomeEvent: "¡Odd modificado con éxito!",
  actionCantBeUndone: "¡Esta acción no se puede deshacer!",
  scratch: "Raspadita",
  liveCasino: "Casino en Vivo",
  roulette: "Ruleta",
  paymentProvider: "Provedor",
  cantVerifyBank:
    "No es posible realizar la verificación bancaria porque solo tienes Pay4Fun como proveedor activado.",
  continue: "Continuar",
  solicitedWithdrawId: "ID de Retiro Solicitado",
  withdraw: "Retiro",
  manual: "Manual",
  minDeposit: "El monto mínimo de depósito es de $ {min_stake}.",
  maxDeposit: "El monto máximo de depósito es de $ 20.000.",
  cantDeactivatePaybrokers:
    "No es posible deshabilitar este método porque tienes habilitada la verificación bancaria.",
  paymentProviders: "Proveedores de Pago",
  seeMethods: "Ver e editar métodos de pago",
  wallet: "Wallet Pay4Fun",
  vinculoDeposit: "Vínculo de depósito",
  vinculoDepositTooltip: `
    Lo vínculo de depósito es una regla que impide que el depositado retire el importe sin utilizarlo para apostar. 
    <br> Con esta opción habilitada, si un jugador deposita $ 100, solo podrá retirar esta cantidad después de haber usado la misma cantidad en las apuestas.
    <br> Con esta opción deshabilitada, no se generará ningún vínculo de depósito en futuros depósitos.
    `,
  minBet: "Apuesta Mínima *",
  promotionTitle: "Título *",
  title: "Título",
  and: "e",
  rolloverMultiplier: "Multiplicador de Rollover *",
  rolloverMultiplier2: "Multiplicador de Rollover",
  adhesionRules: "Reglas de Adhesión",
  rolloverRules: "Reglas de Rollover",
  promotionImage: "Imagen de Promoción *",
  promotionImageWithoutAsterisk: "Imagen de Promoción",
  rewardRules: "Reglas de Recompensas",
  validity: "Validez",
  typeAndCodeOfPromotion: "Tipo de Promoción y Código",
  maxTransferTooltip:
    "Determina la cantidad máxima de transferencia de bonificación al saldo real del jugador a través de esta promoción después de completar el rollover.",
  multiRolloverTooltip:
    "Multiplique el VALOR DEL BONO adquirido por la promoción para definir el rollover total a cumplir para transformar el bono en saldo real. Ej: si el bono es BRL 200,00 y el multiplicador de rollover es 5x. El rollover total a completar será de BRL 1000,00",
  daysToRollover:
    "Número de días que tendrá el jugador para completar el rollover después de unirse a la promoción.",
  transfers: "Transferências",
  transfer: "Transferência",
  freeRounds: "Rounds Gratis Cassino",
  entryId: "ID de Entrada",
  userName: "Nombre de Usuario",
  gainedBonus: "Bonificación Ganada",
  transferedCredit: "Crédito Transferido",
  promotionId: "ID de Promoción",
  affiliateId: "ID del Afiliado",
  affiliateName: "Nombre del Afiliado",
  copyAffiliateLink: "Copiar Enlace de Afiliado",
  delete: "Borrar",
  deletePromotion: "Eliminando Promoción",
  areYouSureYouWantToDeleteThePromotion:
    "¿Estás seguro de eliminar la promoción? Esta acción es irreversible.",
  deletingPromotionUserRollover:
    "Los usuarios que ya hayan optado por esta promoción no se verán afectados. Podrán completar el rollover normalmente.",
  updatingPromotion: "Actualizando Promoción",
  browserCachingImage: `A veces, el navegador puede "recordar" la imagen anterior y
    sigue mostrándolo. Para comprobar la nueva imagen, simplemente actualice
    la página o consultar la promoción en el sitio. tu imagen sera
    actualizado normalmente`,
  promotionLink: "Enlace de Promoción",
  apurationByCasinoGame: "Apuración de Afiliado por Juego de Casino",
  deletingMainEvent: "Borrando Evento Principal",
  loadingEvents: "Cargando eventos",
  addMainEvent: "Agregar Evento a los Eventos Principales",
  removeMainEvent: "Eliminar Evento de los Eventos Principales",
  noMainEvents:
    "No se ha seleccionado ningún evento principal. Agregar eventos principales en ",
  mainEvents: "Eventos Principales",
  mainEventsWhere:
    "Los eventos principales se muestran en la parte superior de su sitio, abajo del carrusel.",
  mainEventsWeFeedIt:
    "Todos los días alimentamos tus eventos principales con los juegos con mayor potencial de apuestas.",
  mainEventsFinalUserSees:
    "Los eventos principales pueden ser de cualquier deporte. Solo los eventos de hoy que aún no han comenzado se mostrarán al jugador.",
  mainEventsYouCanAddHere: "Puede agregar eventos principales en la lista de ",
  prizePercentage: "Porcentaje de Premio",
  eventNumberNeededForAgentPrizePercentage: "Número de Eventos Necesarios",
  clientGains: "Cliente Recibe",
  savePdf: "Salvar PDF",
  documentVerification: "Verificación Documento",
  verificationOfDocument: "Verificación de Documento",
  loadingPlayers: "Cargando jugadores",
  validatingDocument: "Validación de Documento",
  documentFront: "Prueba de Identidad (Frente)",
  documentVerse: "Prueba de Identidad (Reverso)",
  faceBiometry: "Imagen de La Cara",
  confirmPlayerValidation:
    "¿Realmente quieres {type} al jugador con ID {userId}?",
  concluded: "Concluido",
  verification: "Verificación",
  documentVerificationTooltip:
    "Puede revisar los documentos que no han cumplido con los criterios de aceptación automática y aprobar a los usuarios para verificar.",
  deny: "Denegar",
  lowerCaseValidate: "validar",
  lowerCaseDeny: "denegar",
  accept: "Aceptar",
  variableCommissionSingular: "Comisión Variable",
  fixedCommission: "Comisión Fija",
  commissionsOnlyInteger:
    "La comisión no puede ser una cantidad fraccionaria, solo un número entero.",
  feeValueOnlyInteger:
    "La valor de la tarifa no puede ser una cantidad fraccionaria, solo un número entero.",
  variableCommissions: {
    label: "Comisiones Variables",
    description: `Las comisiones variables son comisiones personalizadas que puede
    asignar a sus afiliados en función de su <b>NGR (GGR - Tarifa do Afiliado)</b>. Caso
    tener comisiones llenas y seleccione la comisión variable para el
    afiliado, la comisión que se le aplique será la variable.`,
    errors: {
      fromCantBeEqualOrLessThanUntil: `El valor "De:" no puede ser igual o mayor que el valor "Hasta:".`,
      from: `El valor "De:" no puede ser menor o igual que el valor anterior "Hasta:".`,
      fromSuggestion: `El intervalo entre "Hasta:" y "De:" no puede ser mayor a 1. Sugerimos poner el valor {value}.`,
      until: `El valor "Hasta:" no puede ser menor que el valor "De:".`,
      comissionBelow0: "La comisión no puede ser inferior a 0.",
      comissionBelowOnli0: "La comisión en vivo no puede ser inferior a 0.",
      comissionAbove20: "Atención: comisión superior al 20%.",
      comissionAbove20onli: "Atención: comisión en vivo mayor al 20%.",
      intValue: "La comisión necesita ser un número entero.",
      intValueOnli: "La comisión en vivo necesita ser un número entero.",
    },
  },
  profit: {
    prematch: "Beneficio Estimado Prematch",
    live: "Beneficio Estimado Ao Vivo",
    superOdd: "Beneficio SuperOdd",
    showSuperOdd: "Mostrar SuperOdd en el evento",
    tooltip:
      "SuperOdd mostrará el valor original tachado y el valor aumentado resaltado cuando la margen esté aumentando la cotización.",
    displayingSuperOdd: "Mostrando superOdd!",
    hidingSuperOdd: "Ocultando SuperOdd!",
  },
  commissionEqualOrGreaterThan100:
    "El valor introducido está por encima del valor permitido. El valor máximo de la comisión es del 99%.",
  commissionEqualOrGreaterThan100Onli:
    "El valor ingresado está por encima del límite permitido. El valor máximo para la comisión en vivo es del 99%.",
  feeValueEqualOrGreaterThan100:
    "El valor introducido está por encima del valor permitido. El valor máximo de la tarifa es del 99%.",
  commissionValue: "Valor Comisión",
  switchDescription: `Este campo es el modo de comisión actual del afiliado. <br> Si está habilitado,
el porcentaje de comisión de ese afiliado utilizado en los cálculos de
informes será el fija, que es el campo del lateral. <br> Si está deshabilitado,
la comisión de afiliado será la variable, que se puede configurar
en la lista de afiliados.`,
  variable: "Variable",
  "2fa": {
    otpSent:
      "Se ha enviado un código a su teléfono celular registrado. Insértelo aquí.",
    resending: "Reenviando",
    resendCode: "Reenviar Código",
    wait: "Aguarde {seconds}s",
    verify: "Verificar",
    verifying: "Verificando",
    registerPhone: `Como medida de seguridad, ahora es necesario autenticarse en dos
    factores al iniciar sesión en su panel de control. No tienes un celular registrado,
    entonces debe registrarlo aquí para recibir el código de autenticación.`,
    necessaryMeasure: "Medida Necesaria",
    confirmPhone:
      "Confirma que este celular realmente es tuyo. En caso de error, tendrás que contactar con soporte para cambiarlo.",
    choosenPhone: "Celular Elegido: ",
    confirmPhoneTitle: "Confirmar Celular",
    codeRequired: "Código Necessário",
    resendCodeShort: "Reenviar {seconds}s",
  },
  createNewEvent: {
    createEvent: "Crear evento",
    eventCreationTitle: "Crear nuevo evento",
    leagueCreationTitle: "Crear nueva liga",
    drawer: "Mis Eventos",
    description:
      "Los mis eventos son eventos personalizados creados por usted, con deportes y ligas personalizados. También puede establecer las cotizaciones del equipo y, una vez que finalice el evento, establecer el ganador.",
    setResult:
      "Puede definir un ganador haciendo clic en el icono del pincel en la columna Acciones.",
    creatingEvent: "Creando evento",
    eventCreated: "Evento creado con éxito!",
    updateResult: "Actualizar Resultado",
    confirmUpdateResult:
      "¡Atención! ¿Confirmar la selección de {selectedOdd} como ganador del evento?",
    marketInsert: "Mercado: ",
    selectWinnerAlert: {
      hasNotStarted:
        "No es posible seleccionar la cuota ganadora ya que el evento aún no ha comenzado.",
      finished: "El evento ya tuvo a su ganador seleccionado.",
    },
    form: {
      selectALeague: "Selecionar uma liga",
      registerOdds: "Cadastrar odds",
      registerEvent: "Cadastrar evento",
      teamOne: "Time 1",
      teamTwo: "Time 2",
      leagueName: "League name",
      riskFactor: "Factor de riesgo de la liga",
      min: "Mínimo",
      med: "Promedio",
      max: "Máximo",
      selectWinnerOdd: "Selecionar Odd Vencedora",
      creatingLeague: "Creando liga",
      leagueCreated: "¡Liga creada con éxito!",
      riskFactorDescription: `El peso de la liga influirá en el monto total de responsabilidad del evento. <br/>
      Si es un máximo, el jugador podrá utilizar el porcentaje que le corresponda en el monto total de responsabilidad en el evento. <br/>
      Si es promedio, solo puede apostar la mitad de la cantidad total de responsabilidad en el evento. <br/>
      Si es mínimo, habrá una gran limitación en el monto total de la responsabilidad en el evento.`,
    },
    errors: {
      selectDay: "Seleccione el día del evento.",
      invalidDay: "El día del evento no es válido.",
      eventDateAlreadyHappened: "La fecha del evento ya sucedió.",
      moreThanSevenDays:
        "No se pueden insertar eventos con fecha de inicio mayor a 7 días a partir de ahora.",
      selectHourAndMinute: "Seleccione la hora y el minuto del evento.",
      negativeHour:
        "La hora del evento solo puede ser un número positivo entre 0 y 23.",
      wrongHour: "La hora del evento solo puede ser un número entre 0 y 23.",
      negativeMinute:
        "El minuto del evento solo puede ser un número positivo entre 0 y 59..",
      wrongMinute:
        "El minuto del evento solo puede ser un número entre 0 y 59.",
      creatingEventError:
        "Hubo un error inesperado al crear el evento. Soporte de contacto.",
      noOdds: "No hay odds disponibles para este mercado.",
    },
  },
  minActivePlayersDescription:
    "Al definir un número mínimo de usuarios activos para el afiliado en el periodo de consultas que se realicen, de no existir dicho número mínimo, el afiliado no será comisionado. Usuario activo: hizo una apuesta en deportes o casino.",
  payments: {
    tab: "Pagos",
    makePayment: "Realizar pagos",
    pay: "Pagar",
    historic: "Histórico",
    loadingAffiliates: "Cargando afiliados",
    noDataFound: "Datos no disponibles",
    eligibleForPayment:
      "El afiliado elegible es el afiliado que ha vinculado una cuenta de jugador a su cuenta. El afiliado puede hacer este proceso ingresando la cuenta y contraseña de su cuenta de jugador, en su panel en Transferencias -> Vincular Jugador.",
    eligible: "Elegible",
    eligiblePlural: "Elegible",
    notEligiblePlural: "No Elegible",
    eligibleValue: "Comisión Total (Elegible)",
    valueAll: "Comisión Total (Todos)",
    linkedPlayer: "Jugador Vinculado",
    makingPayment: {
      affiliatesBeingPaid: "Afiliados sendo pagos: {count}",
      totalValue: "Valor total:",
    },
    selectElegibleAffiliates: "Seleciona Elegible Affiliates",
    removeElegibleAffiliates: "Remove Elegible Affiliates",
    invoiceId: "Id da Fatura",
    paymentDate: "Día de Pago",
    withInvoice: "Con Factura",
    withoutInvoice: "Sin Factura",
  },
  providerRequired: "Seleccione un proveedor.",
  removed: "Remoto",
  freespins: {
    resume: "Resumen de Freespins",
    totalPending: "Total Pendiente",
    totalActive: "Total Activo",
    totalExpired: "Total Expirado",
    totalRemoved: "Total Eliminado",
    totalFinalized: "Total Finalizado",
    balanceTotal: "Saldo Total",
    createCampaign: "Crear Campaña",
    claimTooltip: "Lista de usuarios que reclamaron esta campaña",
    name: "Freespins",
    create: "Criar campaña",
    view: "Ver campaña",
    update: "Actualizar campaña",
    roundsQuantity: "Número de rondas",
    campaignId: "ID Campaña",
    loading: "Cargando campañas",
    adhesionsLoading: "Cargando adhesións",
    startDate: "Fecha/hora início",
    endDate: "Fecha/hora final",
    inProgress: "En Progreso",
    progressiveSpins: "Freespins Progresivo",
    progressiveSpinsInfo: `Las tiradas gratuitas progresivas permiten al jugador recibir un número de tiradas gratuitas proporcional a la cantidad depositada.
    Este número puede variar de 1 a 4 y se utilizará como divisor sobre la cantidad depositada. Dos ejemplos rápidos: <br>
    <ul>
    <li>
      Si la progresividad está ajustada a 1, y el usuario deposita 10 R$, recibirá 10 freespins. Si deposita 20 reales, recibirá 20 tiradas gratuitas, porque la cantidad depositada dividida por 1 es la misma.
    </li>
    <li>
      Cuando la progresividad está ajustada a 2, y el usuario deposita 10¤, recibirá 5 tiradas gratuitas. Si deposita 20 reales, recibirá 10 tiradas gratuitas, y así sucesivamente.
    </li>
    </ul>`,
    progressive: "Progresivo",
    form: {
      subheaders: {
        createYourCampaign: "Crea tu campaña",
        editYourCampaign: "Editar tu campaña",
        campaignConfigurations: "Configuraciones de campaña",
      },
      campaignTitle: "Título de la campaña",
      campaignCode: "Código de campaña",
      campaignType: "Tipo de campaña",
      campaignVisibility: {
        title: "Visibilidad de la campaña",
        hide: "Ocultar campaña",
        show: "Ver campaña",
        tooltip:
          "Al seleccionar esta opción, la campaña estará oculta para el usuario final en el momento del depósito (si es un depósito) y en la página Campañas, pero aún podrá unirse usando el código. {updateMessage}",
        tooltipUpdateMessage:
          "Puedes editar esta opción después de crear la campaña.",
        },
      progressiveSpins: "Freespins Progresivo",
      progressiveSpinsDivider: "Freespins progresivo (Divisor)",
      game: "Juego",
      users: "Usuarios que pueden reclamar",
      doCSVUpload: "Cargar CSV",
      inputCsvLabel: "Archivo",
      see: "Ver",
      CSVUploadTip: "El archivo CSV debe contener una columna 'Id'",
      idColumnEmpty: "La columna 'id' no existe o los valores de la columna están vacíos",
      fileNotAllowed: "El archivo no tiene formato .csv",
      rounds: "Cantidad de rondas",
      roundsHint: "Del 1 al 100",
      selectAProvider: "Seleccione un proveedor",
      daysToExpire: "Días para expirar",
      startDate: "Fecha de inicio",
      startTime: "Hora de inicio",
      endDate: "Fecha final",
      endTime: "Hora final",
      manualUsers: "Buscar jugadores que recibirán giros gratis",
      campaignCodeTip:
        "Código que utilizará el jugador para unirse a la campaña.",
      campaignMinimumDepositTip:
        "Monto mínimo que el apostador necesita depositar para poder unirse a la campaña.",
      depositBondMultiplier: "Multiplicador de vínculo de depósito",
      depositBondMultiplierTooltip:
        "El vinculo de deposito garantiza que el apostante juegue la cantidad depositada antes de retirarla.<br/>Al establecer un multiplicador, hasta 5, el jugador tendrá que jugar con el monto del depósito multiplicado por el multiplicador establecido antes de poder retirar.",
      freeSpinsRolloverInfo: "El multiplicador del rollover garantiza que el apostador juegue la cantidad depositada antes de canjear los giros gratis.<br/>Al establecerlo en 100x, el jugador tendrá que jugar la cantidad depositada multiplicada por el multiplicador establecido antes de canjear sus giros gratis."
    },
    campaignTypeOptions: {
      custom: "Personalizado",
      deposit: "Depósito",
      firstDeposit: "Primer depósito",
    },
    playersOptions: {
      newUsersLast30Days: "Registrado en los últimos 30 días",
      activeLast30Days: "Activo en los últimos 30 días",
      usersWithDeposits: "Activos que han depositado (Últimos 30 días)",
      usersWithoutDeposits: "Activos que no han depositado (Últimos 30 días)",
      addByIdOrName: "Agregar por ID, login o nombre",
      addByCsv: "Añadir por fichero CSV",
    },
    dateAndHour: "Fecha y hora de reclamo de freespins",
    dateAndHourEnd: "Fecha y hora de vencimiento de freespins",
    titleWhatYouWannaDo: "¿Qué quieres hacer?",
    cancelPromotionAndFreespinsAdhered:
      "Cancelar promoción y giros gratis de todos los jugadores que ya se han unido",
    cancelFreespinsAdhered:
      "Cancelar promoción sin eliminar suscripciones ya realizadas",
    removeAlert: "Esta acción es irreversible.",
    remove:
      "¿Está seguro de que desea eliminar al jugador <strong>{player}</strong> de la campaña de giros gratis <strong>{title}</strong>?",
    deleteFreespinAlert:
      "¿Está seguro de que desea deshabilitar la campaña de freespins <strong>{title}</strong>?",
    removingAdhesion: "Eliminando membresía",
    removingFreespin: "Eliminando freespins",
    finalFreespinDate: "Fecha de finalización de freespin: {date}",
    notClaimed: "No reclamado",
    totalSelectedPlayers: "Total de jugadores seleccionados:",
    selectedPlayers: "Jugadores Seleccionados",
    viewSelectedPlayers: "Ver jugadores seleccionados",
  },
  firstPasswordRegistration: {
    rules: {
      description: "Tu contraseña debe cumplir con estos requisitos:",
      oneUppercaseLetter: "Se requiere al menos una letra mayúscula",
      oneLowercaseLetter: "Se requiere al menos una letra minúscula",
      oneSpecialCharacter:
        "Se requiere al menos un carácter especial (#?!@$%^&*-)",
      oneNumber: "Se requiere al menos un número",
      eightCharacters: "La contraseña debe tener exactamente 8 caracteres",
      confirmation: "La contraseña y la confirmación deben coincidir",
    },
  },
  categoryNotFound: "Categoría no encontrada",
  newInvoices: {
    name: "Nuevas Facturas",
    oldInvoices: "Facturas Antiguas",
    appliedValue: "Valor Aplicado",
    readQrCode: "Lee el código QR",
    copyPixCode: "Copiar código PIX",
    loading: "Cargando facturas...",
    generatePix: "Generar Pix",
    overdue: "Atrasado",
    invoiceValue: "Valor de Factura",
    feeValue: "Valor Honorarios",
  },
  fixed: "Fixo",
  cpfTooltip:
    "Este campo está destinado al CPF del responsable de la operación. Este campo se utilizará para generar facturas del sistema, si necesita modificarlo, busque el sector financiero o gerente de cuenta",
  billingEmailTooltip:
    "Este correo electrónico debe ser llenado con un correo electrónico válido, ya que se utilizará como remitente para el envío de correos electrónicos de confirmación, recuperación de cuenta, entre otros.",
  pixPhysicalPersonAlert:
    "Muy importante: Esta foto debe pagarse con una cuenta de Persona Física, no con una cuenta de Persona Jurídica.",
  revShareValue: "Valor Rev Share",
  fixedOdd: "Odds Fijas",
  hidePromotionTooltip:
    "Al seleccionar esta opción, la promoción se ocultará al usuario final en el momento del depósito (si se realiza el depósito) y en la página de Promociones, pero aún se puede ingresar usando el código. Es posible editar esta opción después de crear la promoción.",
  hidePromotionTooltipUpdateMessage:
    "Puedes editar esta opción después de crear la promoción.",
  loadingPromotions: "Cargando promociones",
  promotionVisibility: "Visibilidad de la promoción",
  visibility: "Visibilidad",
  hidePromotion: "Ocultar promoción",
  hidden: "Oculta",
  displayed: "Desplegada",
  createNewWebhook: "Crear nuevo webhook",
  editWebhook: "Editar webhook",
  loadingWebhooks: "Cargando webhooks",
  marginChangedAlertMessage:
    "El cambio en el margen {type} de {oldMargin} a {currentMargin} puede beneficiar a los usuarios al momento del retiro.",
  testWebhook: "Probar webhook",
  whatAreWebhooks: `Webhook es una tecnología utilizada para permitir la comunicación entre dos aplicaciones y enviar notificaciones en tiempo real.
  <br />
  Al registrar un webhook, recibirá una notificación en la URL proporcionada siempre que se complete la acción elegida.`,
  unexpectedError: "Ocurrió un error inesperado.",
  dataBeingSent: "Datos que se envían (JSON)",
  response: "Respuesta",
  success: "Éxito",
  error: "Error",
  hide: "Ocultar",
  emailVerification: {
    name: "Verificación por email al momento del retiro",
    button: "Verificar email",
    dialogTitle: "Verificar email del jugador",
    description: "Esta acción hará que el jugador pueda realizar retiros.",
    areYouSure:
      "¿Estás seguro de que quieres verificar el email del jugador? Esta acción es irreversible.",
    forWithdraws: `Al seleccionar "Sí", el jugador solo podrá realizar un retiro si su correo electrónico está verificado. (Recomendado)
    Al seleccionar "No", el jugador podrá realizar un retiro sin verificación previa.`,
  },
  claims: "Reclamaciones",
  multifactor: {
    field: "Autenticación de dos factores",
    tooltip:
      "La autenticación de dos factores permite a los usuarios activar una capa extra de seguridad en sus cuentas, recibiendo un código en su celular cuando inician sesión en la plataforma.",
  },
  homePage: {
    field: "Pagina principal",
    tooltip:
      "Esta es la página que sus visitantes verán primero cuando accedan a su sitio web.",
  },
  expenses: {
    logs: {
      createExpense: "Creación de gastos de afiliados",
      editExpense: "Edición de gastos de afiliados",
      removeExpense: "Eliminación de gastos de afiliados",
    },
  },
  affiliatesCampaigns: {
    noData: "No hay campañas activas. | No hay campañas inactivas.",
    noDataFound: "No se encontraron campañas.",
    name: "Nombre de la campaña",
    campaignCode: "Código de campaña",
    affiliateName: "Nombre del afiliado",
    numberOfClicks: "Cantidad de clics",
    numberOfUsers: "Cantidad de usuarios",
    socialMedia: "Red social",
    others: "Otros",
    activate: "Activar",
    desactivate: "Desactivar",
    activateOrDesactivate: "Activar o desactivar",
    createdDate: "Fecha de creación",
    updatedDate: "Fecha de actualización",
  },
  activateOrDesactivateCampaign: {
    title: "Confirmar acción",
    description: {
      activate: "¿Está seguro de que desea activar la campaña: ",
      desactivate: "¿Está seguro de que desea desactivar la campaña: ",
    },
  },
  sortBy: "Ordenar por",
  activeCampaigns: "Campañas Activas",
  desactiveCampaigns: "Campañas inactivas",
  resultsPlurals: "resultado | resultados",
  usersPlurals: "Usuario | Usuarios",
  depositsPlurals: "Deposit | Deposits",
  withdrawalsPlurals: "Retiro | Retiros",
  noQuery: "No se ha realizado ninguna consulta",
  lastLogin: "Ultimo acceso",
  birthday: "Nacimiento",
  noDataText: "No hay datos",
  noResultsText: "No hay datos para esta búsqueda",
  finalizedIn: "Finalizado en",
  withdrawalStatus: {
    requested: "Solicitado",
    authorized: "Autorizado",
    consolidated: "Consolidado",
    cancelled: "Cancelado",
  },
  lastBetTime: "Hora de la última apuesta",
};

export default es;
